import { BonusInfo } from './../../interface/bonus-info.interface';
import { DocumentService } from './../../services/document.service';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environments/environment';
import { ApiUrlConstants } from '../../../common/constants/api.constants';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../../common/pipes/currency-format.pipe';
import { FindErrorCodesPipe } from '../../../common/pipes/errorFind.pipe';
import { GroupByPipe } from '../../../common/pipes/group-by.pipe';
import { TitleCasePipe } from '../../../common/pipes/title-case.pipe';
import { TranslateKey } from '../../../common/pipes/translate-key.pipe';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { ContactType } from '../../../shared/enums/contact-type.enum';
import { Country } from '../../../shared/interface/country.interface';
import { DisplayPriceConfig } from '../../../shared/interface/display-price-config.interface';
import { MemberAllowedCountries } from '../../../shared/interface/member-allowed-countries.interface';
import { Member } from '../../../shared/interface/member.interface';
import { StoreConfig } from '../../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../../shared/interface/user-info.interface';
import { WholesaleQualifiedResponse } from '../../../shared/interface/wholesaleQualifiedResponse.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../../shared/services/member-display-price-config.service';
import { MessageService } from '../../../shared/services/message.service';
import { CustomValidators } from '../../../shared/Utils/custom-validator';
import { Utils } from '../../../shared/Utils/utils';
import { Constants, DelivaryOptionType, MemberType, ProductSource } from '../../common/constants';
import { DeliveryPreference, MemberLevel, OrderSources, OrderType, PurchaseFlow, RowStatus } from '../../common/enumerations';
import { DateConstants } from '../../constants/date.constants';
import { MemberTypeId } from '../../constants/member-type-id.enum';
import { PaymentConstants } from '../../constants/payment.constants';
import { PhoneCodesConstants } from '../../constants/phone-codes.constant';
import { PortalDisplayPage } from '../../constants/portal-display-page.enum';
import { EcheckPhoneNumberValidation } from '../../directive/echeck-phone-validation';
import { AccountType } from '../../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../../enums/echeck-portal-types.enum';
import { ImageType } from '../../enums/image-type.enum';
import { MemberOrderType } from '../../enums/member-order-type.enum';
import { MemberStatus } from '../../enums/member-status.enum';
import { MemberTitleExtEnums } from '../../enums/member-title.enum';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { MessageTypeEnum } from '../../enums/message-type.enums';
import { NotificationType } from '../../enums/notification-types.enum';
import {
    AddressType, OrderSourceType,
    OrderStatus, PaymentMethodTypes, PaymentType,

    PosPaymentMethodsEnum, PriceType,
    ProductWeightMetric,
    PurchaseFlows,
    PurchaseFlowType, ShippingOrderType, ShippingType, Source
} from '../../enums/order-source-type';
import { MemberActivityLogType } from '../../../shared/common/enumerations';
import { ActivityLogKey } from '../../interface/activityLogKey';
import { OrderSourceTypes, OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentCardTypes } from '../../enums/payment-card-types.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PosPaymentGroupEnum } from '../../enums/pos-payment-group.enum';
import { ProductMetatDataValue } from '../../enums/product-metadata.enum';
import { SelectEnum } from '../../enums/selection.enum';
import { ShippingMemberTitle } from '../../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../../enums/shipping-member-type.enum';
import { ValueType } from '../../enums/value-type.enum';
import { Address } from '../../interface/address';
import { AppCountryConfig } from '../../interface/app-config';
import { CheckoutConfig } from '../../interface/checkout-config.interface';
import { DiscountPercentageResponse } from '../../interface/discount-percentage.response.interface';
import { PersonalCheck } from '../../interface/eCheck/payment-echeckrequest.interface';
import { TokenResponse } from '../../interface/eCheck/token-response.interface';
import { ValidateEcheckRequest } from '../../interface/eCheck/validate-echeck-request.interface';
import { ValidateEcheckResponse } from '../../interface/eCheck/validate-echeck-response.interface';
import { Order, SponsorInformation } from '../../interface/enrollment';
import { FBOBusinessEntity } from '../../interface/fbo-business-entity';
import { MemebrCCOverrideResponse } from '../../interface/member-ccoverride-response.interface';
import { MemberLevelHistory } from '../../interface/member-level-history.interface';
import { MemberOrderCCInfo } from '../../interface/member-order-cc-info';
import { OrderRulesRequest } from '../../interface/order-rules-request.interface';
import { OrderRulesResponse } from '../../interface/order-rules-response.interface';
import { PaymentRequestModel } from '../../interface/payment-request-model.interface';
import { PaymentResponseModel } from '../../interface/payment-response-model.interface';
import { PayvisionSavedCardResponse } from '../../interface/payvision/payvision-saved-card-response.interface';
import { PayvisionSavedCard } from '../../interface/payvision/payvision-saved-card.interface';
import { PriceTierResponse } from '../../interface/price-tier-response';
import { Product, ProductAssociation } from '../../interface/product-info';
import { ShippingOptionsRequest } from '../../interface/shipping-options-request';
import { ShippingProductModel } from '../../interface/shipping-product.interface';
import { TaxRequest } from '../../interface/tax-request';
import { TaxType } from '../../interface/tax-type.interface';
import { Cart } from '../../models/cart.model';
import { OrderInfoTab } from '../../models/order-info-tab-model';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { PosPaymentMethod } from '../../models/pos-payment-method.modal';
import { AppConfigService } from '../../services/app-config.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { CustomerService } from '../../services/customer.service';
import { EcheckService } from '../../services/echeck.service';
import { OrderService } from '../../services/order.service';
import { PayvisionService } from '../../services/payvision.service';
import { DisplaySectionId, Portal } from '../../enums/document-library-member-id.enum';
import { DocumentLibrary } from '../../interface/document-library.interface';
import { PayByLinkInitiatePayment } from '../../../shared/interface/adyen/pay-by-link-initiate-payment.interface';
import { ResponseStatus } from '../../constants/response-status-constants';
import { PriceTier } from '../../constants/pricetier.constants';
import { ImpersonateUserConstants } from '../../constants/impersonate-user.constants';
import { AccountRestrictionStatus } from '../../../common/enums/account-restricted.enum';
import { CommonConstant } from '../../../shared/constants/common.constants';
import { ConfigurationService } from '../../services/configuration.service';
import { BonusConstants } from '../../constants/bonus-status.constants';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { IntegratedTerminalConfiguration } from '../../interface/integratedTerminalConfiguration';
import { MULTI_SELECT_CONFIG_INTEGRATED_TERMINAL } from '../../../shared/selectize/selectize.config';
import { IntegratedTerminalTransactionStatus } from '../../interface/integratedTerminalTransactionStatus';
import { transactional } from '../../enums/sponsor-transactional-source-type.enum';

@Component({
    selector: 'pos-order-promotion',
    templateUrl: '../../templates/template1/views/pos-orders/pos-order-promotion.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/pos-order-promotion.less','../../templates/template1/themes/default/less/print-preview.less'
    ],
    providers: [FindErrorCodesPipe, TitleCasePipe, GroupByPipe]
})
export class PosOrderPromotionComponent implements OnInit {
    @Input() fboid: string;
    @Input() orderFromLookup: boolean;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    terminalPaymentStatusCheckPollingCount: number =  environment.terminalPaymentStatusCheckPollingCount;
    cartMessageID: any;
    memberInfo: any;
    memberTypeId: any;
    memberTypeEnum = MemberTypeEnum;
    orderType: any = OrderType;
    posOrderFormGroup: FormGroup;
    items: any[] = [];
    countries: any[] = [];
    states: any[] = [];
    memberSearchSubmitted = false;
    posLocations:any[]= [];
    currentPosLocation:any;
    address: any;
    countryTaxInclusive: boolean;
    storeInfo: StoreConfig;
    shipMethodValidation: any = '';
    subTotal = 0.0;
    retailSubTotal = 0.0;
    totalCommissionableVolume = 0;
    selectedIsoCountryCode: any = '';
    selectedCountryCodeTwo = '';
    selectedPaymentMethod: any;
    paymentBillingAddress:any={};
    isSubmitted = false;
    products: any[] = [];
    posRetailMemberEligibleCountries: any[]=[];
    posRetailmembrEligible :any;
    orderSubmitted = false;
    orderTaxResponse: any;
    taxableAmount = 0;
    searchReqValues: any;
    shipMethod: any = {};
    languageCode = 'en-US';
    languageShortCode = 'en';
    payByLinkLanguageCulture ='en-US';
    payByLinkLanguageCode = 'en';
    pollCount = 0;
    maxPollCount = 15;
    importFeeValue = 0;
    importFeeEnabled = false;
    selectEnum = SelectEnum;
    posPaymentGroupEnum = PosPaymentGroupEnum;
    userInfo: UserInfo;
    memberStatus;
    isActive;
    storeId: number;
    credit_Card_show: boolean;
    echeck_show: boolean;
    gstTax: number;
    pstTax: number;
    isOverrideMinimumLimit:boolean=false;
    storeDefaultLanguage: string;
    taxCalculationStatus = true;
    minMaxPriceValidation: boolean;
    isFocused: boolean;
    displayPriceConfig: DisplayPriceConfig;
    memberLevelHistory: MemberLevelHistory[];
    isMemberFboUpgraded = false;
    upgradeFboLimitExceeded = false;
    isFBOValidationPending = false;
    phoneNumberFormat: string;
    isMemberEligibleToPlaceOrder = false;
    memberTypeNotification:any;
    handlingCharges = 0;
    productwareHouseLocation:any[];
    overrideMinimumLimitIsEnabled:boolean=false;
    @ViewChild('overrideMinimumLimit') overrideMinimumLimit:Modal;
    @ViewChild('paymentModal') paymentModalPopup: Modal;
    @ViewChild('payvisionPayment') payvisionPayment: Modal;
    @ViewChild('eCheckPaymentPopup') eCheckPaymentPopup: Modal;
    @ViewChild('showWorldPayXMLPopup') showWorldPayXMLPopup: Modal;
    @ViewChild('showAdyenPaymentPopup') showAdyenPaymentPopup: Modal;
    @ViewChild('showNexioPopup') showNexioPopup: Modal;
    @ViewChild('showNIPopup') showNIPopup: Modal;
    @ViewChild('paymentProcessing') paymentProcessingPopup: Modal;
    @ViewChild('shipMethodId') shipMethodId: ElementRef;
    @ViewChild('creditCardPayment') creditCardPayment: ElementRef;
    @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
    @ViewChild('eCheckPayment') eCheckPayment: ElementRef;
    @ViewChild('savedCardsDdl') savedCardsDdl: ElementRef;
    @ViewChild('savedEcheckDdl') savedEcheckDdl: ElementRef;
    @ViewChild('outOfStockModal') outOfStockModal: Modal;
    @ViewChild('saveEcheckFormBtn') saveEcheckFormBtn: ElementRef;
    @ViewChild('seachItemElement') seachItemElement: ElementRef;
    @ViewChild('itemLevelSearch') itemLevelSearch: ElementRef;
    billingAddressInfo: any;
    paymentComponentSettings: PaymentComponentSettings = new PaymentComponentSettings();
    countryCode: string;
    addNewpayvisionCard: boolean;
    selectedpayvisionCardInfo: any;
    orderSession: any = {};
    isOrderSessionInfo: boolean;
    addNeweCheck: boolean;
    selectedECheckInfo: PersonalCheck;
    echeckForm: FormGroup;
    accountTypes: Array<string>;
    echeckRequest: PersonalCheck;
    eCheckTokenRes: string;
    savedEChecks: string;
    isWorldpayPayment: boolean;
    isAdyenPayment:boolean;
    isNIPayment: boolean;
    showWorldpayXml: boolean;
    showAdyenPayment:boolean;
    showNIPayment: boolean;
    echeckSubmitted: boolean;
    CreatePOSOrderInfo: any;
    eCheckValidationMessages: Array<String>;
    checkoutConfig: CheckoutConfig;
    appConfig: AppCountryConfig;
    FBOPOSOrderPermissions: number[] = [
        Permission.POS_ORDER_CREATE,
        Permission.POS_ORDER_MANAGE
    ];
    hasPOSOrderPermissions: boolean;
    showPOSOrderValidation: boolean;
    storePaymentInfo;
    money_Order_show: boolean;
    bank_transfer_show: boolean;
    cash_on_delivery_show: boolean;
    thresholdCrossed: boolean;
    memberCCLimitExceeded: boolean;
    orderRules: OrderRulesResponse;
    memberOrderCCInfo: MemberOrderCCInfo;
    personalDiscountPercentage: number;
    savePaymentMethod: boolean;
    monthlyCCValue: number;
    memberCCOverride: MemebrCCOverrideResponse;
    memberCCOverrideLimitExceeded: boolean;
    memberCart: Cart;
    shoppingCartCount = 0;
    isRestrictionPopupOpened: boolean;
    outOfStockItems: Product[];
    sponsorInformation: SponsorInformation;
    fieldErrors: any[];
    distributorMaxCC: number;
    memberDiscountPercentage: DiscountPercentageResponse;
    addNewCardClicked: boolean;
    isMemberHasAccessToOrder = true;
    restrictedDays = 0;
    cartLimitExceed = false;
    cartLimitNotReach = false;
    paymentTypeEnum = PaymentType;
    bankDetailsList = [];
    //shippingTax: number;
    shippingMethodId:number;
    storeID:number;
    isQuantityUpdate = false;
    previousQuantity : number = 1;
    paymentForm : FormGroup;
    splitPayments: any[] = [];
    balanceOrderTotal:number;
    orderTotal:number;
    posPaymentMethods:PosPaymentMethod[] = [];
    posPaymentGroups:any = [];
    isEnterPaymentDetailsEnabled:boolean = false;
    isPaymentBlockEnabled:boolean = false;
    externalPaymentForm:FormGroup;
    splitPaymentForm:FormGroup;
    paymentMethodTypeForm : FormGroup;
    placeOrderClicked:boolean = false;
    posPaymetMethodsEnum = PosPaymentMethodsEnum;
    taxType = TaxType;
    businessEntityId:number;
    integratedPaymentMethods:PosPaymentMethod[] = [];
    paymentMethodTypes = PaymentMethodTypes;
    emailForm: FormGroup;
    isPayByLinkValid = true;
    storeDefaultLanguageShortCode: string;
    payByLinkLanguageShortCode: any;
    paymentTermsAndPoliciyDocuments: DocumentLibrary[];
    agreementCheckError: boolean;
    acceptPaymentDocuments = null;
    memberBonusInfo: any;
    searchProduct: any;
    enableBackDateOrder = false;
    operatingCountry:any=[];
    overrideMinimumOrderLimitPermissions: number[]=[
        Permission.OVERRIDE_MINIMUM_LIMIT
    ]
    hasMinimumOverrideLimit:boolean=false;
    isWhosaleCheckNotCalculated = false;
    // accountStatus: any;
    accountRestriction: boolean;
    memberDetails: { fboId: any; firstName: any; lastName: any; memberLevel: any; };
    accountViewPermission: boolean = false;
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    storeLanguageCode: string;
    depsoitFeeProductsInfo: Product[] = [];
    productAssociationInfo: ProductAssociation[] = [];
    purchaseFlowType: any;
    sessionGuid: any;
    isTaxMetaDataAvailable: boolean;
    isWorldPayEnabledCountry: boolean;
    dropShipDeliveryOptionDisabled = false;
    shippingDeliveryOptionAvailable = false;
    pickupDeliveryOptionAvailable = false;
    deliveryOptionPurchaseFlow:string;
    deliveryOptionResponse:any;
    disableQty: boolean = false;
    isNexioPayment:boolean = false;
    showNexioPayment:boolean = false;
    enableNexioPaymentForPickUpCenter:boolean = environment.enableNexioPaymentForPickUpCenter;
    isSingleDistributionCenter: boolean = false;
    terminalOptions: Array<IntegratedTerminalConfiguration> = [];
    terminalDownConfig: any;
    preselectTerminal: any = [];
    isTerminalSelected: boolean = false;
    displayTryAgain: boolean = false;
    terminalDetails: IntegratedTerminalConfiguration;
    terminalPOIId: any;
    terminalTransactionID: any;
    terminalTransactionCancelButton: boolean = true;
    isStoreDiscounPercentagetConfigured: boolean = false;
    isNewCardClicked: boolean = false;
    ignoreAddNewCards: boolean = false;
    constructor(private _orderService: OrderService,
        private _echeckService: EcheckService,
        private _sanitizer: DomSanitizer,
        private _formbuilder: FormBuilder,
        private _http: Http,
        private _commonService: CommonService,
        private _translatePipe: TranslateService,
        private _translateKey: TranslateKey,
        private _currencyPipe: CurrencyTransformPipe,
        private _cacheService: CacheService,
        private _customerService: CustomerService,
        private messageService: MessageService,
        private _payvisionService: PayvisionService,
        private _titleCase: TitleCasePipe,
        private _maskPipe: MaskPipe,
        private _checkoutConfigService: CheckoutConfigService,
        private _configurationService: ConfigurationService,
        private _memberDisplayPriceConfigService: MemberDisplayPriceConfigService,
        private chRef: ChangeDetectorRef,
        private _appConfigService: AppConfigService,
        private _translateService: TranslateService,
        private _documentService: DocumentService,
        private _groupByPipe: GroupByPipe,
        @Inject(DOCUMENT) private document: any
    ) {
    }
    ngOnInit(): void {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.retrieveOrderInfoSession();
        this.businessEntityId =this.orderSession && this.orderSession.businessEntityId ? this.orderSession.businessEntityId : null;
                sessionStorage.removeItem(CacheKey.OrderInfo);
        this.getDistributorInfoFromStorage();
        this.buildForm();
        this.getOperatingCountries();
        if(this.orderSession && this.orderSession.paymentComponentSettings && this.orderSession.paymentComponentSettings.webOrderId){
            const country = this.orderSession.paymentComponentSettings.isoCountryCode;
            const webOrderId = this.orderSession.paymentComponentSettings.webOrderId;
            this.clearAllTheForms(true);
            this.openOrderViewTab(webOrderId,country);
        }
        this.getAllPermissions();
        //this.getPosMemberEligible();
        this.getCountries();
        this.getStates();
        this.orderSession!=null && this.orderSession.isOverrideMinimumLimit===true?this.isOverrideMinimumLimit=true:this.isOverrideMinimumLimit=false;
        if (this.orderSession) {
           this.minMaxPriceValidation = this.orderSession.minMaxPriceValidation;
        }
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.selectedPaymentMethod = PaymentMethodTypes.Credit_Card.toString();
        // this.orderFromLookup || this.isOrderSessionInfo
        //     ? (document.getElementById('country') ? document.getElementById('country').focus() : null)
        //     : (document.getElementById('memberInfo') ? document.getElementById('memberInfo').focus() : null);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        if (this.userInfo && !this.orderSession) {
            this.getPosLocations();
        }
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);

    }
    retrieveOrderInfoSession() {
        try{
            this.orderSession = (sessionStorage.getItem(CacheKey.OrderInfo) && (sessionStorage.getItem(CacheKey.posOrderPaymentStatus))? (sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.SUCCESS ||
             sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.FAILED || sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.CANCEL ||  sessionStorage.getItem(CacheKey.posOrderPaymentStatus).toUpperCase() === PaymentStatus.CANCELLED ) : false) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        }catch (error){
            console.error(error)
            sessionStorage.removeItem(CacheKey.OrderInfo);
            sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        }
    }

    // getting Pos Locations from UserInfo
    getPosLocations() {
        this.isWhosaleCheckNotCalculated = false;
        const posLocationID = [];
        if (this.userInfo && this.userInfo.hasSystemRole) {
            this._customerService.getAllPosLocations().subscribe((response: any) => {
                this.posLocations = response;
                this.assignDefaultLocation();
            });
        }
        else {
            if (this.userInfo && this.userInfo.allowedPosLocations.length) {
                this.userInfo.allowedPosLocations.forEach((item) => {
                    posLocationID.push(item.posLocations);
                });
            }
            this._customerService.getPosLocations(posLocationID).subscribe((response: any) => {
                this.posLocations = response;
                this.assignDefaultLocation();
            });
        }
    }

    getDistributorInfoFromStorage(): void{
        this.CreatePOSOrderInfo = this._cacheService.get('CreatePOSOrderInfo');
        this._cacheService.remove('CreatePOSOrderInfo');
        if (this.CreatePOSOrderInfo) {
            if(this.CreatePOSOrderInfo.distributorId){
                this.orderFromLookup = true;
            }else{
                this.orderFromLookup = false;
            }
            this.fboid = this.CreatePOSOrderInfo.distributorId;
        }
    }

    assignDefaultLocation(): void {
        let selectedPOSLocation = sessionStorage.getItem(CacheKey.SelectedPOSLocation);
        if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
            if ((this.orderSession && this.orderSession.posLocation) || selectedPOSLocation) {
                this.posOrderFormGroup.controls['posLocation'].setValue(selectedPOSLocation || this.orderSession.posLocation);
                this.changePosLocation(selectedPOSLocation || this.orderSession.posLocation);
            }
            else {
                this.posOrderFormGroup.controls['posLocation'].setValue(0);
            }
        }
        else if (this.posLocations && this.posLocations.length) {
            this.posOrderFormGroup.controls['posLocation'].setValue(this.posLocations[0].id);
            this.posOrderFormGroup.controls['posLocation'].updateValueAndValidity();
            this.isSingleDistributionCenter = true;
            this.changePosLocation(this.posLocations[0].id);
        }
    }

//    getPosMemberEligible(){
//     this._commonService.getPosMembrOrderElible().subscribe((response: any[]) => {
//         if (response) {
//            this.posRetailMemberEligibleCountries=response;
//         }
//     });
//    }
   
   getFormControls() {
    const items: any = this.posOrderFormGroup.get('items');
    return items.controls;
}

    /**
     * @description This method used to get all permissions
     * getAllPermissions()
     * @memberof OrderPromotionComponent
    */
    getAllPermissions(): void {
        this.hasPOSOrderPermissions = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + this.FBOPOSOrderPermissions + ']'), AccessLevel.Customer_Service);
        this.hasMinimumOverrideLimit=this._commonService.checkPermissionByAccessLevel(
            JSON.parse('['+ this.overrideMinimumOrderLimitPermissions +']'),AccessLevel.Customer_Service);
    }

    /**
     * build Form
     */
    buildForm() {
           this.posOrderFormGroup = this._formbuilder.group({
            orderType:this.orderType.POS,
            memberInfo: ['', [Validators.required, Utils.noEmptyString, Utils.searchByMemberValidation]],
            items: this._formbuilder.array(this.items),
            shipMethodId: ['', [Validators.required]],
            itemSearch: [''],
            itemLevelSearch: [''],
            paymentInstrumentId: [''],
            paymentSelector: [],
            saveForFutureUse: [false],
            language: [],
            backDateOrder: [false],
            posLocation: ['', [Validators.required]]
        });
        if (this.orderSession && this.orderSession.splitPayments
            && this.orderSession.splitPayments.length > 0) {
            this.splitPayments = this.orderSession.splitPayments;
            this.posOrderFormGroup.controls['paymentSelector'].setValue('4');
        }
    }

    buildPaymentForm():void{
        this.buildSplitPaymentForm();
        this.buildExternalPaymentForm();
        this.buildPayByLinkForm();
        this.createPaymentMethodTypeForm();
        if(this.posPaymentGroups.find((paymentGroup)=>paymentGroup.id === this.posPaymentGroupEnum.External_Payment)){
            this.posOrderFormGroup.controls['paymentSelector'].setValue(this.posPaymentGroupEnum.External_Payment);
            this.posOrderFormGroup.controls['paymentSelector'].updateValueAndValidity();
            this.onPaymentMethodGroupChange(this.posPaymentGroupEnum.External_Payment);
        }
        else if(this.posPaymentGroups.find((paymentGroup)=>paymentGroup.id === this.posPaymentGroupEnum.Integrated_Payments)){
            this.posOrderFormGroup.controls['paymentSelector'].setValue(this.posPaymentGroupEnum.Integrated_Payments);
            this.posOrderFormGroup.controls['paymentSelector'].updateValueAndValidity();
            this.balanceOrderTotal = 0;
            this.onPaymentMethodGroupChange(this.posPaymentGroupEnum.Integrated_Payments);
        }
        else if(this.posPaymentGroups.find((paymentGroup)=>paymentGroup.id === this.posPaymentGroupEnum.Split_Payment)){
            this.posOrderFormGroup.controls['paymentSelector'].setValue(this.posPaymentGroupEnum.Split_Payment);
            this.posOrderFormGroup.controls['paymentSelector'].updateValueAndValidity();
            this.onPaymentMethodGroupChange(this.posPaymentGroupEnum.Split_Payment);
        }

        // let payments:any = this.paymentForm.get('payments') as FormArray;
        // if (this.orderSession
        //     && this.orderSession.splitPayments && this.orderSession.splitPayments.length > 0) {
        //     this.balanceOrderTotal= this.orderSession.orderTotal;
        //     this.paymentComponentSettings= this.orderSession.paymentComponentSettings;
        //     this.orderSession.splitPayments.forEach(x => {
        //         if (x) {
        //             payments.controls[x.index].controls['paymentType'].setValue(x.paymentType);
        //             payments.controls[x.index].controls['amount'].setValue(x.amount);
        //             payments.controls[x.index].controls['paymentType'].updateValueAndValidity();
        //             payments.controls[x.index].controls['amount'].updateValueAndValidity();
        //             this.balanceOrderTotal = this.balanceOrderTotal - Number(payments.controls[x.index].controls['amount'].value);
        //         }
        //     });
        // }
    }

    buildExternalPaymentForm(){
        this.externalPaymentForm = this._formbuilder.group({payments:this._formbuilder.array([])});
        let payments:any = this.externalPaymentForm.get('payments') as FormArray;
        if (this.posPaymentMethods) {
            this.posPaymentMethods.forEach((paymentMethod) => {
                if (paymentMethod.paymentMethodsModel.paymentGroupID === this.posPaymentGroupEnum.External_Payment) {
                    const paymentFormGroup = this._formbuilder.group(
                        {
                            paymentMethodId: [''],
                            paymentStatus: [''],
                            amount: [''],
                            paymentNote: [''],
                            paymentCheckNumber:[''],
                        }
                    );
                    payments.push(paymentFormGroup);
                }
            });
        }
        if(this.posPaymentGroups && this.posPaymentGroups.find((paymentGroup)=>paymentGroup.id === this.posPaymentGroupEnum.External_Payment)){
            if(payments.length > 0){
                payments.controls[0].controls['paymentMethodId'].setValue(this.getPaymentMethodId(this.posPaymentGroupEnum.External_Payment,0));
                payments.controls[0].controls['amount'].setValidators([Validators.required]);
                payments.controls[0].updateValueAndValidity();
            }
        }
    }

    getMemberBonusInfo() {
        if (this.memberInfo && this.memberInfo.memberId) {
            this._customerService.getMemberBankDetails(this.memberInfo.memberId).subscribe(
                (response) => {
                    if (response) {
                        this.memberBonusInfo = response;
                    }
                }
            );
        }
    }

    /**
     * @description Creating the delivery options form
     * @memberof PaymentComponent
     */
    private createPaymentMethodTypeForm(): void {
        this.paymentMethodTypeForm = this._formbuilder.group({
            preselectTerminal: '',
            paymentMethodType: ['']
        });
    }

    clearPaymentMethodTypeFormForm(): void {
        this.paymentMethodTypeForm.reset({
          preselectTerminal: '',
          paymentMethodType: ''
        });
      }

    buildSplitPaymentForm(){
        this.splitPaymentForm = this._formbuilder.group({payments:this._formbuilder.array([])});
        let payments = this.splitPaymentForm.get('payments') as FormArray;
        payments.push(this.getPaymentFormGroup());
    }

    getPaymentFormGroup(){
        let paymentFormGroup = this._formbuilder.group(
            {
                paymentMethodId:[''],
                paymentStatus : [''],
                amount : [''],
                paymentNote : [''],
                paymentCheckNumber : [''],
            }
        );
       return paymentFormGroup;
    }

    addNewSplitPaymentGroup(){
        let payments:any = this.splitPaymentForm.get('payments') as FormArray;
        if(payments.length<5){
            payments.push(this.getPaymentFormGroup());
        }
    }
    removeSplitPaymentGroup(){
        let payments:any = this.splitPaymentForm.get('payments') as FormArray;
        if(payments.length!==1 && payments.controls[payments.length-1].controls['amount'].value==''){
            payments.removeAt(payments.length-1);
        }
    }

    getPaymentMethodName(groupId,index):string{
       let payments = this.posPaymentMethods.filter((paymentMethod)=>paymentMethod.paymentMethodsModel.paymentGroupID===groupId);
       if(payments && payments.length > 0){
           return payments[index].paymentMethodsModel.paymentMethodName;
       }else{
           return "";
       }
    }
    getPaymentMethodId(groupId,index):any{
        let payments = this.posPaymentMethods.filter((paymentMethod)=>paymentMethod.paymentMethodsModel.paymentGroupID===groupId);
        if(payments && payments.length > 0){
            return payments[index].paymentMethodsModel.paymentMethodId;
        }else{
            return '';
        }
    }

    paymentTypeChange(value: PaymentMethodTypes, index: number): void {
        let payments:any = this.paymentForm.get('payments') as FormArray;
        const paymentModel = {
            paymentType: payments.controls[index].controls['paymentType'].value,
            amount: payments.controls[index].controls['amount'].value,
            index: index
        }
        this.balanceOrderTotal=this.balanceOrderTotal-Number(payments.controls[index].controls['amount'].value);
        this.splitPayments.push(paymentModel);
        if (value === PaymentMethodTypes.Credit_Card) {
            this.selectSavedCard(null, true,Number(payments.controls[index].controls['amount'].value));
        }
    }

    selectPaymentMethodType(paymentMethod): void {
        this.isTerminalSelected = false;
        if(paymentMethod && paymentMethod.paymentMethodsModel &&  paymentMethod.paymentMethodsModel.paymentMethodId === PaymentType.INTEGRATED_TERMINAL) {
            this.isTerminalSelected = true;
            if(!this.paymentMethodTypeForm.controls['preselectTerminal'].value || !this.terminalDetails){
                let terminalDetails = this._cacheService.get(CacheKey.SelectedTerminalDetails)
                this.paymentMethodTypeForm.controls['preselectTerminal'].setValue(terminalDetails ? terminalDetails : null);
                this.terminalSelection(terminalDetails);
            }
        }
        if(paymentMethod && paymentMethod.paymentMethodsModel &&  paymentMethod.paymentMethodsModel.paymentMethodId === this.paymentTypeEnum.Pay_By_Link) {
            const email = this.memberInfo ? this.memberInfo.email : '';
            if(email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            } else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if(this.emailForm.controls['payByLinkEmail'].value !== '') {
            this.isPayByLinkValid = true;
            } else {
                this.isPayByLinkValid = false;
            }
        } 
        else if(this.enableNexioPaymentForPickUpCenter && paymentMethod.paymentMethodsModel.paymentMethodId === this.paymentTypeEnum.Nexio_Credit_Card) {
             this.isPayByLinkValid = true;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                let isDefaultCard = false;
                let isCardAdded = false;
                this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                    if (card.expired === false && isDefaultCard === false) {
                        isDefaultCard = true;
                        isCardAdded = true;
                        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                        this.selectSavedCard(card);
                    }
                });
                if(!isCardAdded){
                    this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
                    this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    this.selectSavedCard(null,true);
                }
            }
            else{
                this.selectSavedCard(null,true);
            }
        }        
        else {
            this.isPayByLinkValid = true;
        }

        if(paymentMethod && paymentMethod.paymentMethodsModel &&  paymentMethod.paymentMethodsModel.paymentMethodId === this.paymentTypeEnum.Direct_Debit) {
            this.checkPaymentDocumentsSelected();
        } else {
            this.agreementCheckError = false;
        }
    }

    /**
     * place POS order
     */
    createPosOrder() {
        const items: any = this.posOrderFormGroup.get('items');
        let productids: number[] = [];
        items.value.forEach(element => {
            productids.push(element.productId);
        });
        this.posStockAvailabilityCheck(productids,+this.posOrderFormGroup.controls['posLocation'].value,true);
        if(this.isOverrideMinimumLimit ===true) {
        this.saveMemberActivityLog(this.memberInfo.memberId,MemberActivityLogType.Override_Minimum_Limit);
        }
    }
    createPosOrderUpdate(){
        let paymentData:any;
        if(+this.posOrderFormGroup.controls['paymentSelector'].value===this.posPaymentGroupEnum.External_Payment){
            const externalPaymentData: any = this.getSelectedExternalPaymentData();
            paymentData =externalPaymentData;
            if(+externalPaymentData.amount !== this.calculateOrderTotal() && +this.posOrderFormGroup.controls['paymentSelector'].value===this.posPaymentGroupEnum.External_Payment){
                const errorMessage: any = this._translatePipe.get('Entered amount is not matching with Order Total');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            }else{
                this.proceedPlaceOrder(paymentData);
            }
        } if (+this.posOrderFormGroup.controls['paymentSelector'].value === this.posPaymentGroupEnum.Integrated_Payments) {

            if(this.paymentMethodTypeForm.controls['paymentMethodType'].value== this.paymentTypeEnum.Pay_By_Link ) {
                const initiatePaymentRequest = this.prepareInitiatePaymentRequest();
                this.initiatePayment(initiatePaymentRequest);
            } else if(this.paymentMethodTypeForm.controls['paymentMethodType'].value==this.paymentTypeEnum.Saved_Cards ||
                (this.enableNexioPaymentForPickUpCenter && this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Nexio_Credit_Card)) {
           const creditCardPaymentData= this.getSelectedCreditCardData();
           paymentData =creditCardPaymentData;
           this.proceedPlaceOrder(paymentData);
            } else if (this.paymentMethodTypeForm.controls['paymentMethodType'].value == PaymentType.INTEGRATED_TERMINAL) {                
                this.prepareIntegratedPaymentData();
            }
            if (this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Direct_Debit) {
                const creditCardPaymentData = this.getIntegratedPaymentData();
                paymentData = creditCardPaymentData;
                this.proceedPlaceOrder(paymentData);
            }
        }
    }

    getIntegratedPaymentData() {
        let data = {};
        data = {
            paymentGroupId: this.posPaymentGroupEnum.Integrated_Payments,
            paymentMethodId: this.paymentMethodTypeForm.controls['paymentMethodType'].value,
            paymentMethodName: PosPaymentMethodsEnum[+this.paymentMethodTypeForm.controls['paymentMethodType'].value],
            paymentMethodType: PosPaymentMethodsEnum[+this.paymentMethodTypeForm.controls['paymentMethodType'].value],
            paymentStatus: '',
            paymentNote: '',
            paymentCheckNumber:'',
            amount: ''
        };
        return data;
    }


    prepareInitiatePaymentRequest():PayByLinkInitiatePayment  {
        const orderDescription = this.products && this.products &&
        this.products.length > 0 ? this.products[0].name : 'order description';
        const initiatePaymentRequest:PayByLinkInitiatePayment = {
            email: this.emailForm.value.payByLinkEmail,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            firstName: this.memberInfo.firstName,
            lastName: this.memberInfo.lastName,
            languageCode: this.payByLinkLanguageCode,
            languageCulture: this._commonService.getLanguageCulture(this.storeInfo, this.countryCode, this.memberInfo),
            customerId: this.memberInfo.memberId,
            paymentMethodType: PaymentMethodTypes.Pay_By_Link,
            countryCode: this.selectedIsoCountryCode,
            amount: {
                currency: this.storeInfo.currencyCode,
                value: this.calculateOrderTotal()
            },
            distributorId: this.memberInfo.fboId,
            orderTypeId: this.orderType.POS,
            webOrderID:this.paymentComponentSettings.webOrderId,
            orderReferenceId:this.paymentComponentSettings.orderReferenceId,
            storeID:this.storeInfo.id,
            orderSource:OrderSources.POS,
            description: orderDescription,
            shippingAddress: this.getPayByLinkShippingAddress()
        }
        return initiatePaymentRequest;
    }

    getPayByLinkShippingAddress() {
        const address = {
            addressLine1: this.storeInfo.warehouseAddress.addressLine1 ? this.storeInfo.warehouseAddress.addressLine1 : '',
            addressLine2: this.storeInfo.warehouseAddress.addressLine2 ? this.storeInfo.warehouseAddress.addressLine2 : '',
            city: this.storeInfo.warehouseAddress.city ? this.storeInfo.warehouseAddress.city : '',
            countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
            state: this.storeInfo.warehouseAddress.stateCode ?  this.storeInfo.warehouseAddress.stateCode : '' ,
            zip: this.storeInfo.warehouseAddress.zipCode ? this.storeInfo.warehouseAddress.zipCode : ''
        };
        return address;
    }
    initiatePayment(initiatePaymentRequest: PayByLinkInitiatePayment) {
        this._payvisionService.initiatePayment(initiatePaymentRequest)
                .subscribe((response: any) => {
                    if (response && response.authorizeResponse && response.authorizeResponse.paymentStatus === PaymentStatus.PEND) {
                        this.openOrderViewTab(response.authorizeResponse.orderID);
                        this.clearAllTheForms(true);
                    }                    
                },
                    (error: any) => {
                        this.placeOrderClicked = false;
                        const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                        this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                    }
                );
    }
    proceedPlaceOrder(paymentData:any){
        this.placeOrderClicked = true;
        if((this.paymentMethodTypeForm.controls['paymentMethodType'].value==this.paymentTypeEnum.Saved_Cards || this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Nexio_Credit_Card ) && this.selectedpayvisionCardInfo && !this.isNewCardClicked){
            this.submitPayment(paymentData);
            }else if (!(this.paymentMethodTypeForm.controls['paymentMethodType'].value==this.paymentTypeEnum.Saved_Cards || this.paymentMethodTypeForm.controls['paymentMethodType'].value == this.paymentTypeEnum.Nexio_Credit_Card )){
                this.submitPayment(paymentData);
            }
            else{
                this.placeOrderClicked = false;
                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            }
    }

    submitPayment(paymentData:any){
        this._payvisionService.submitPayment(this.constructPaymentRequestModel(paymentData, null))
        .subscribe((response: PaymentResponseModel) => {
             if (response && (response.paymentStatus ===PaymentStatus.SUCCESS || response.paymentStatus ===PaymentStatus.AUTH) ) {
                 this.openOrderViewTab(response.orderID);
                 this.paymentComponentSettings.webOrderId = '';
                 this.clearAllTheForms(true);
              }else{
                this.placeOrderClicked = false;
                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
              }
        },
            (error: any) => {
                this.placeOrderClicked = false;
                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            }
        );
    }
    
    initiateTerminalPayment(initiatePaymentRequest: PayByLinkInitiatePayment) {
        this.terminalTransactionCancelButton = true;
        this._payvisionService.initiatePayment(initiatePaymentRequest)
            .subscribe((response: any) => {
                if (this.paymentComponentSettings.webOrderId && response) {
                    if (response.terminalResponse && response.terminalResponse === Constants.OK && response.terminalPaymentStatusResponse && response.terminalPaymentStatusResponse.transactionID) {
                        this.terminalTransactionID = response.terminalPaymentStatusResponse.transactionID;
                        this.terminalTransactionCancelButton = false;
                        this.getTerminalPaymentStatus(0);
                    } else {
                        this.paymentProcessingPopup.close();
                        this.setErrorNotification(response);
                        this.onEditCartClick();
                        this.displayTryAgain = true;
                    }
                }
            },
                (error: any) => {
                    this.paymentProcessingPopup.close();
                    this.placeOrderClicked = false;
                    const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                    this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                    this.onEditCartClick();
                    this.displayTryAgain = true;
                }
            );
    }

    getTerminalPaymentStatus(count) {
        if (!this.paymentComponentSettings.webOrderId) {
            this.paymentProcessingPopup.close();
        } else {
            const terminalPaymentStatus: IntegratedTerminalTransactionStatus = {
                storeId: this.storeId,
                paymentMethodId: PaymentType.INTEGRATED_TERMINAL,
                orderSource: OrderSources.POS,
                saleID: this.paymentComponentSettings.webOrderId,
                poiid: this.terminalPOIId,
                paymentTransactionNo: this.terminalTransactionID ? this.terminalTransactionID : null,
                orderReferenceId: +this.paymentComponentSettings.orderReferenceId,
                storePOSTerminalId: this.terminalDetails.id
            }
            this._orderService.getTerminalPaymentStatus(terminalPaymentStatus)
                .subscribe((response: any) => {
                    if (this.paymentComponentSettings.webOrderId && response) {
                        if (this.validateTerminalStatusFailureResponse(response) && (response.terminalPaymentStatusResponse.paymentResponseErrorCondition === PaymentStatus.IN_PROGRESS || response.terminalPaymentStatusResponse.paymentResponseErrorCondition === PaymentStatus.MESSAGE_FORMAT) && this.terminalPaymentStatusCheckPollingCount && this.terminalPaymentStatusCheckPollingCount > 0) {
                            if (count <= this.terminalPaymentStatusCheckPollingCount) {
                                setTimeout(() => {
                                    count++;
                                    this.getTerminalPaymentStatus(count);
                                }, 5000)
                            } else {
                                this.paymentProcessingPopup.close();
                                this.placeOrderClicked = false;
                                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                                this.onEditCartClick();
                                this.displayTryAgain = true;
                            }
                        } else if (this.validateTerminalStatusFailureResponse(response) && (response.terminalPaymentStatusResponse.paymentResponseErrorCondition.toUpperCase() === PaymentStatus.CANCEL || response.terminalPaymentStatusResponse.paymentResponseErrorCondition === PaymentStatus.ABORTED)) {
                            this.paymentProcessingPopup.close();
                            this.setErrorNotification(response.terminalPaymentStatusResponse);
                            this.onEditCartClick();
                            this.displayTryAgain = true;
                        } else if (this.validateTerminalStatusSuccessResponse(response)) {
                            this.paymentProcessingPopup.close();
                            if (response.terminalPaymentStatusResponse.saleID) {
                                this.openOrderViewTab(response.terminalPaymentStatusResponse.saleID);
                                this.clearAllTheForms();
                            }
                        } else {
                            this.setErrorNotification(response.terminalPaymentStatusResponse);
                            this.paymentProcessingPopup.close();
                            this.onEditCartClick();
                            this.displayTryAgain = true;
                        }

                    }
                },
                    (error: any) => {
                        this.paymentProcessingPopup.close();
                        this.placeOrderClicked = false;
                        const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                        this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                        this.onEditCartClick();
                        this.displayTryAgain = true;
                    }
                );
        }
    }
    
    cancelTerminalPayment() {
        if (!this.paymentComponentSettings.webOrderId) {
            this.paymentProcessingPopup.close();
        } else {
            this.terminalTransactionCancelButton = true;
            let terminalPaymentStatusCheckPollingCount = 0;
            if(this.terminalPaymentStatusCheckPollingCount && this.terminalPaymentStatusCheckPollingCount > 0) {
                terminalPaymentStatusCheckPollingCount = this.terminalPaymentStatusCheckPollingCount > 2? this.terminalPaymentStatusCheckPollingCount - 2 : this.terminalPaymentStatusCheckPollingCount;
            }
            const cancelTerminalPayment: IntegratedTerminalTransactionStatus = {
                storeId: this.storeId,
                paymentMethodId: PaymentType.INTEGRATED_TERMINAL,
                orderSource: OrderSources.POS,
                saleID: this.paymentComponentSettings.webOrderId,
                poiid: this.terminalPOIId,
            }
            this._orderService.cancelTerminalPayment(cancelTerminalPayment).subscribe((response: any) => {

                if (this.paymentComponentSettings.webOrderId && response) {
                    if (response.terminalResponse && response.terminalResponse === PaymentStatus.SUCCESS) {
                        this.getTerminalPaymentStatus(terminalPaymentStatusCheckPollingCount);
                    }
                }
            },
                (error: any) => {
                    this.getTerminalPaymentStatus(terminalPaymentStatusCheckPollingCount);
                }
            );
        }
    }

    validateTerminalStatusFailureResponse(response) {
        if (response.terminalPaymentStatusResponse && response.terminalPaymentStatusResponse.paymentStatus && response.terminalPaymentStatusResponse.paymentStatus === PaymentStatus.FAILURE && response.terminalPaymentStatusResponse.paymentResponseErrorCondition) {
            return true;
        }
        return false;
    }

    validateTerminalStatusSuccessResponse(response) {
        if (response.terminalPaymentStatusResponse && response.terminalPaymentStatusResponse.paymentStatus && response.terminalPaymentStatusResponse.paymentStatus === PaymentStatus.SUCCESS) {
            return true;
        }
        return false;
    }

    setErrorNotification(response) {
        if (response.validations && response.validations.message) {
            let errorMessage = response.validations.message;
            if (errorMessage.includes('+') || errorMessage.includes('message=')) {
                errorMessage = errorMessage.replace(/\+/g, ' ');
                errorMessage = errorMessage.replace(/message=/g, '');
            }
            this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
        }        
    }

       enablePaymentBlock(status:boolean){
           if(status){
               this.isPaymentBlockEnabled=true;
               this.isEnterPaymentDetailsEnabled = false;
           }else{
                this.isPaymentBlockEnabled = false;
                this.isEnterPaymentDetailsEnabled = false;
           }
       }

     /**
     *
     * @param paymentMethod
     * @param paymentInformation
     * @param paymentComponentSettings
     */
    constructPaymentRequestModel(paymentMethod: any,
        paymentInformation: any): PaymentRequestModel {
        const orderDescription = this.products && this.products &&
        this.products.length > 0 ? this.products[0].name : 'order description';
        const paymentRequestModel: PaymentRequestModel = {
            token: (paymentMethod.paymentGroupId === 2 && this.selectedpayvisionCardInfo && this.selectedpayvisionCardInfo.token)? this.selectedpayvisionCardInfo.token : paymentInformation ? paymentInformation.paymentToken : null,
            orderReferenceId: this.paymentComponentSettings.orderReferenceId,
            orderDescription: orderDescription,
            amount: this.calculateOrderTotal(),
            storeId: this.storeId,
            countryCode: paymentMethod.paymentGroupId === 2 ?this.selectedCountryCodeTwo : this.selectedIsoCountryCode,
            currencyCode: this.storeInfo.currencyCode,
            paymentMethodType: paymentMethod.paymentMethodName,
            paymentMethodId : paymentMethod.paymentMethodId,
            paymentGroupId: paymentMethod.paymentGroupId,
            orderSourceTypeId: OrderSourceValue.POS,
            notes:paymentMethod.paymentNote,
            checkNumber :paymentMethod.paymentCheckNumber,
            customerId: this.memberInfo && this.memberInfo.memberId ? this.memberInfo.memberId : null,
            orderTypeId: this.orderType.POS,
            // billingAddress: null, // this.getBillingAddress(),
            billingAddress:  this.paymentBillingAddress,
            paymentAch: paymentInformation ? paymentInformation.paymentAch : null,
            paymentCheck: paymentInformation ? paymentInformation.paymentECheck : null,
            externalToken: paymentInformation ? paymentInformation.externalToken : null,
            paymentRequestModel: null, // for payvison - need to add logic,
            webOrderId: this.paymentComponentSettings.webOrderId,
            distrubutorId: paymentMethod.distrubutorId
        };
        return paymentRequestModel;
    }


    /**
     * @description To get Bank Details for Bank Transfer Payment method.
     * @author Akhil
     * @date 2020-05-11
     * @memberof OrderPromotionComponent
     */
    getBankDetails() {
        let bankDetails = this._translateService.get(PaymentConstants.BankTransfer)['value'];
        if (bankDetails != PaymentConstants.BankTransfer) {
            for (let key in bankDetails) {
                if (key.indexOf(PaymentConstants.BankDetails) > -1) {
                    this.bankDetailsList.push(bankDetails[key]);
                }
            }
        }
    }

  /**
  *allows only numbers  with decimal value.
  */
 allowOnlyDecimalValues(event:any,groupId:number,index:number){
  if(event.keyCode !==8 && event.keyCode !==46 ){
  const regex = new RegExp("^[0-9]+$");
  const value =event.key ;
  if (!regex.test(value)) {
    event.preventDefault();
  }
}}

    getStatesCodeByByStateId(stateId:number):any {
      let stateCode='';
         const  statedetails =this.states.find(item => item.id === stateId);
          if(statedetails){
            stateCode= statedetails.stateCode;
          }
          if(!stateCode){
            const statesOfSelectedCountry = this.states.filter(x=> x.countryCode === this.paymentComponentSettings.isoCountryCode);
            if(statesOfSelectedCountry[0] && statesOfSelectedCountry[0].stateCode){
                stateCode = statesOfSelectedCountry[0].stateCode;
            }
        }
        return stateCode;
    }

    /**
     * set Distributor Info from FboId
     */
    getDistributorInfo() {
        this.posOrderFormGroup.controls['memberInfo'].setValue(this.fboid);
        this.searchMember();
    }
    onKeydown(event: any) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }

    /**
     * create item number
     * @returns FormGroup
     */
    createItemNumberGroup(): FormGroup {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
            isDepositFeeProduct: [false],
            depositFeeEnabled:[false]
        });
    }

    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    getCountries() {
        this._customerService.getCountriesLookup().subscribe(response => {
            if (response) {
                this.countries = response;
                this._cacheService.set(CacheKey.COUNTRIES, this.countries);
                if (this.orderFromLookup && this.fboid) {
                    this.getDistributorInfo();
                } else if (this.isOrderSessionInfo) {
                    this.posOrderFormGroup.controls['memberInfo'].setValue(this.orderSession.memberInfo);
                    this.searchMember();
                    this.posOrderFormGroup.controls['orderType'].setValue(this.orderSession.orderType);
                }
                this.orderFromLookup = this.isOrderSessionInfo ? this.orderSession.orderFromLookup : this.orderFromLookup;
            }
        });
    }

    /**
     * get States
     */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
            }
        });
    }

    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    private getCountryDetailsByCountryIdOrCode(countryId: number, countryCode: string): any {
        let countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter((x: any) => x.countryId === countryId)[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter((x: any) => x.isocodeThree === countryCode)[0];
        }
        return countryObj;
    }

    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    private getStateDetailsByStateIdOrCode(stateId: number, stateCode: string): any {
        let stateObj = {};
        if (stateId) {
            stateObj = this.states.filter((x: any) => x.id === stateId)[0];
        }
        if (stateCode) {
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode)[0];
        }
        return stateObj;
    }

    changePosLocation(posLocationID: any) {
    //    this.clearAllTheForms(false);
        this.clearOnPosLocationChange();
        if (this.posLocations && this.posLocations.length) {
            let posLocations = this.posLocations.find(x => x.id === +posLocationID);
            this.currentPosLocation =posLocations;
            this.storeID = posLocations.storeId;
            this.businessEntityId = null;
            if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                sessionStorage.setItem(CacheKey.SelectedPOSLocation, posLocationID);
            }
            if (posLocations && this.memberInfo) {
                const isAuthorized = this.validatedAuthorizedCountries(posLocations.storeId);
                if (!isAuthorized) {
                    const notification: any = this._translatePipe.get('order.Sorry, this Customer is currently not eligible to purchase in this location. Add country in My Profile / My Global Business.');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                        this.posOrderFormGroup.controls['posLocation'].setValue(0);
                    }
                } else {
                    this.posOrderFormGroup.controls['posLocation'].setValue(posLocationID);
                    this.posOrderFormGroup.controls['posLocation'].updateValueAndValidity();
                    this.storeInfo = null;
                    this.getStoreInfo(this.storeID);
                }
            }
        }
    }

    validatedAuthorizedCountries(storeID : number) : Boolean {
        let isAuthorizedStore = null;
        if (this.memberInfo && this.memberInfo.memberAllowedCountries && this.memberInfo.memberAllowedCountries.length) {
            isAuthorizedStore = this.memberInfo.memberAllowedCountries.find(allowedCountry => allowedCountry.storeId === storeID);
        }
        return isAuthorizedStore;
    }

    /**
     * @description will get Handlig and fee charges based on poslocation
     * @date 2020-10-29
     * @memberof PosOrderPromotionComponent
     */
    getHandlingFeeCharges(): void {
        this.taxCalculationStatus = true;
        this.importFeeValue = 0;
        this.handlingCharges = 0;
        // if shipMethodId formcontrol is not needed we need to remove this line
        this.posOrderFormGroup.controls['shipMethodId'].setValue(+this.posOrderFormGroup.controls['posLocation'].value);
        this.posOrderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        if (this.memberInfo && this.storeInfo && this.products && this.products.length > 0 &&
                this.posOrderFormGroup.controls['posLocation'].value) {
            const shippingOptions = this.prepareShippingOptionsRequest();
            this._orderService.getPOSHandlingFeeCharges(shippingOptions,
                this.posOrderFormGroup.controls['posLocation'].value).subscribe(response => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    this.shipMethod = response.shippingMethods[0];
                    this.importFeeValue = this._currencyPipe
                        .getFormatedCurrency(response.shippingMethods[0].importFeeValue, this.storeInfo);
                    this.handlingCharges = response.shippingMethods[0].shippingCharge;
                    this.shippingMethodId = response.shippingMethods[0].shippingMethodId;
                    this.calculateOrderTax();
                } else if (response && response.validations.length > 0) {
                    this.shipMethodValidation = response.validations[0];
                }
                if (this.isQuantityUpdate) {
                    this.isQuantityUpdate = false;
                }
                this.cartLimitNotReach = false;
            }, error => { });
        }
        console.log("getHandlingFeeCharges taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    }

    /**
     * @description will prepare shipping Options request
     * @date 2020-10-29
     * @returns {ShippingOptionsRequest}
     * @memberof PosOrderPromotionComponent
     */
    prepareShippingOptionsRequest(): ShippingOptionsRequest {
        const shippingOptions: ShippingOptionsRequest = {
            productModels: this.getProductModels(),
            orderSourceId: OrderSourceType.Web,
            languageCode: this.languageCode,
            orderTypeId: ShippingOrderType.Personal,
            fromAddress: this.getWarehouseAddress(),
            toAddress: {},
            storeId: this.storeInfo.id,
            requestID: 2,
            memberTypeId: this.memberInfo && (this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR ||
                this.memberInfo.memberTypeId === this.memberTypeEnum.FPC) ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,
            priceTypeId:  PriceType.WHOLESALEPRICE,
            memberLevelId: this.memberInfo && (this.memberInfo.memberTitleId === MemberLevel.PREFERREDCUSTOMER)
                ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderCaseCredits: this.totalCommissionableVolume,
            purchaseFlowId: PurchaseFlowType.WholeSale,
            shippingTypeId: ShippingType.PICKUP,
            storeHomeCountryCode: this.selectedIsoCountryCode,
            vatInclusive: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false,
            initialOrder: false,
            orderType: this.orderType.POS,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered === true ? this.memberInfo.vatRegistered : false
        };
        return shippingOptions;
    }

    /**
     * get products by Ids
     */
    getProductsByIds(productsIds: Array<number>, storeInfo: StoreConfig) {
        let fpc5PercentEnabled: boolean = false;
        const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        let memberTitleId = this.memberInfo && this.memberInfo.memberLevelId
            ? this.memberInfo.memberLevelId : this.memberInfo.memberTitleId;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        const purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled,false,memberTitleId);
        // HARD_DOWNGRADE CHECK FOR FPC USERS
        memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, storeInfo.id,
            memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin, storeInfo.taxInclusive).subscribe(response => {
                if (response && response.length > 0) {
                    this.loadproducts(response);
                }
            });
    }

    /**
     *load procducts from session
     */
    loadproducts(products: Product[]) {
        products.forEach((product: Product) => {
            this.addItemNumber();
            const items: any = this.posOrderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
                    const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                    if (this.isOrderSessionInfo) {
                        const productInfo = this.orderSession.products.find((item: any) => product.id === item.productId);
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    } else if (this.posOrderFormGroup && !this.isOrderSessionInfo) {
                        let productInfo = null;
                        if (this.memberCart && this.memberCart.items.length > 0) {
                            productInfo = this.memberCart.items.find((item: any) => product.id === item.productId);
                        }
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    }
                }
            }
        });
        this.updateTotalsAndShipMethod();
    }

    /**
     * Get Store Info
     * @param storeId
     */
    getStoreInfo(storeId: any) {
        if (storeId) {
            this._orderService.getStoreById(storeId).subscribe(response => {
                if (response) {
                    const storeInfo = response;
                    this.storeId = response.id;
                    this.countryCode = response.homeIsocodeThree;
                    this.selectedIsoCountryCode = response.homeIsocodeThree;
                    this.storeLanguageCode = response.languages[0].cultureName;
                    const selectedCountry: any = this.countries.find((x: any) => x.isocodeThree.toLowerCase() === this.selectedIsoCountryCode.toLowerCase());
                    if (selectedCountry) {
                        this.memberInfo.vatRegistered = this._commonService.getVatDetail(selectedCountry, this.memberInfo);
                        if (environment.ignoreDisableAddNewCardCheckCountries && selectedCountry.isocodeThree &&  environment.ignoreDisableAddNewCardCheckCountries != "" ){
                            const ignoreDisableAddNewCardCheckCountries = environment.ignoreDisableAddNewCardCheckCountries.split(',');
                            this.ignoreAddNewCards = ignoreDisableAddNewCardCheckCountries.includes(selectedCountry.isocodeThree) ? true : false;
                        }
                        this.checkoutConfig = this._checkoutConfigService.getSettings(selectedCountry.isocodeThree, this.memberInfo);
                        // this.isWorldPayEnabledCountry = this._configurationService.checkWorldPayEnabledCountry(selectedCountry.isocodeThree);
                        if (this.memberInfo && this.memberInfo.memberId && this.checkoutConfig && this.checkoutConfig.displayBusinessEntity) {
                            this.loadMemberBasicInfo(this.memberInfo.memberId);
                        }
                        // if (this.posRetailMemberEligibleCountries) {
                        //     const posMemberConfig: any = this.posRetailMemberEligibleCountries.find(x => x.countryCode === this.countryCode.toUpperCase());
                        //     if (posMemberConfig && this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.RETAIL && posMemberConfig.enablePosOrderForRetail) {
                        //         this.isMemberEligibleToPlaceOrder = false;
                        //     }
                        // }
                        // this.isWorldpayPayment = this.checkoutConfig.isWorldpayPayment;
                        // this.isAdyenPayment = this.checkoutConfig.isAdyenPayment;
                        // this.isNIPayment = this.checkoutConfig.isNIPayment;
                        this.selectedCountryCodeTwo = selectedCountry.isocodeTwo;
                        this.paymentComponentSettings.isoCountryCode = selectedCountry.isocodeThree;
                        this.paymentComponentSettings.isoTwoletterCountryCode = selectedCountry.isocodeTwo;
                     }

                    this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                    this.distributorMaxCC = storeInfo.distributorMaxCC;
                    if (this.memberInfo && this.memberInfo.fboId && this.memberInfo.memberAllowedCountries
                        && this.memberInfo.memberAllowedCountries.length > 0
                        && (+this.memberInfo.memberTypeId === this.memberTypeEnum.FPC || +this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR)) {
                        if (this.selectedIsoCountryCode) {
                            this.getWholsesaleQualifiedDetails(this.memberInfo.fboId, this.selectedIsoCountryCode, storeInfo);
                        } else {
                            this.getMemberDiscountPercentages(storeInfo);
                        }
                    } else {
                        this.getMemberDiscountPercentages(storeInfo);
                    }
                    // delivery options api call
                    let memberType: string;
                    if (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST) {
                        memberType = MemberType.GUEST;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                        if (this.isOrderSessionInfo) {
                            this.sponsorInformation = this.orderSession.sponsorInformation;
                        }
                    } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
                        memberType = MemberType.Distributor;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
                        memberType = MemberType.PREFERRED_CUSTOMER;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    } else if (+this.memberInfo.memberTypeId === MemberTypeEnum.RETAIL) {
                        memberType = MemberType.RETAIL;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    const getDeliveryOptionsRequest: any = {
                        memberTypeId: this.memberInfo ? this.memberInfo.memberTypeId : MemberTypeEnum.RETAIL,
                        memberType: memberType.toUpperCase(),
                        source: Source.POS,
                        countryCode: this.countryCode,
                        purchaseFlow: this.deliveryOptionPurchaseFlow,
                        storeId: this.storeId
                    };
                    this.shippingDeliveryOptionAvailable = false;
                    this.pickupDeliveryOptionAvailable = false;
                    this._orderService.getDeliveryOptions(this.countryCode, getDeliveryOptionsRequest).subscribe(res => {
                        if (res) {
                            this.dropShipDeliveryOptionDisabled = false;
                            this.deliveryOptionResponse = res;
                            res.forEach(option => {
                                if (option.optionValue === DelivaryOptionType.Delivery) {
                                    this.shippingDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Pickup) {
                                    this.pickupDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Dropship) {
                                    if (option.optionDisabled) {
                                        this.dropShipDeliveryOptionDisabled = true;
                                    }
                                    this.pickupDeliveryOptionAvailable = true;
                                }

                            });
                            if (this.deliveryOptionResponse&&(this.pickupDeliveryOptionAvailable||this.shippingDeliveryOptionAvailable)) {
                                this.isMemberEligibleToPlaceOrder = false;
                            }
                        }
                    });
                
                    if(this.storeId && this.storeId > 0 && this.storeId !==response.id ){
                        const items = this.posOrderFormGroup.get('items') as any;
                        if (items && items.length > 0) {
                            while(items.length>0){
                                items.removeAt(0);
                            }
                            this.taxableAmount = 0;
                            this.updateTotalsAndShipMethod();
                            this.getHandlingFeeCharges();
                        }
                    }
                    this.countryTaxInclusive = storeInfo.taxInclusive;
                    this.appConfig = this._appConfigService.getSettings(this.countryCode, this.memberInfo); //storeConfiguration
                    this.getOrderRules(storeInfo);
                    if (response.languages && response.languages.length > 0) {
                        this.storeDefaultLanguage = response.languages.find((languageCulture: any) => languageCulture.default).cultureName;
                        this.payByLinkLanguageCode = this.storeDefaultLanguage;
                        this.payByLinkLanguageShortCode = response.languages.find((languageCulture: any) => languageCulture.default).languageCode;
                        this.languageShortCode = response.languages.find((languageCulture: any) => languageCulture.default).languageCode;
                    } else {
                        this.storeDefaultLanguage = this.languageCode;
                        this.payByLinkLanguageCode = this.payByLinkLanguageCode;
                        this.payByLinkLanguageShortCode = this.payByLinkLanguageShortCode;
                    }
                    this.showPOSOrderValidation = false;
                    this.storeInfo = storeInfo;
                    if (this.memberInfo) {
                    this.memberInfo = {...this.memberInfo, displayMiddleName : this.storeInfo.displayMiddleName};
                    }
                    this.overrideMinimumLimitIsEnabled=this.getOverrideMinimumLimit()
                    this.storeInfo.ccNumberDecimals = 3;
                    this.storeInfo.ccNumberFormat = 'CR';
                    this.storeInfo.ccSymbol = 'CC';
                    this.paymentComponentSettings.languageCode = this.languageCode;
                    this.paymentComponentSettings.storeId = this.storeInfo.id;
                    this.paymentComponentSettings.orderType = OrderSourceTypes.POS,
                    this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
                    this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
                    this.countryCode = this.countryCode;
                    if (this.isOrderSessionInfo) {
                        this.loadproductsFromSession();
                        this.updateTotalsAndShipMethod();
                    }
                    this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
                    this.getPaymentMethodsByStore();
                    this.getHandlingFeeCharges();
                    this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                }

            }, error => {
            const notification: any = this._translatePipe.get('order.Unable to fetch Store Details');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }
}


    /**
     * @description
     * @date 2019-10-21
     * @private
     * @memberof OrderPromotionComponent
     */
    private getMemberDiscountPercentages(storeInfo: StoreConfig): void {
        const optin = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        const wholeSaleQualified = this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false;
        /* Logic changes for CSP-813: CSP - The pricing or Member Type should be considered based on the combination of
            Level, Opt-In, and Wholesale Qualified Status*/
        const memberTitleID = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberInfo) {
            this.memberInfo.transactionalWholesaleQualified = wholeSaleQualified;
            this.memberInfo.transactionalOptin = optin;
        }
        if (this.taxCalculationStatus) {
            this.updateTotalsAndShipMethod();
        }
        this.memberDiscountPercentage = null;
        this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, storeInfo.id).
            subscribe(response => {
                if(response.id){
                    this.memberDiscountPercentage = response;
                    this.isStoreDiscounPercentagetConfigured = true;
                }else{
                    this.isStoreDiscounPercentagetConfigured = false;
                }
            },
            error =>{
                this.memberDiscountPercentage = null;
                const notification: any = this._translatePipe.get('order.Store discount percentage configuration error');
                this.isStoreDiscounPercentagetConfigured = false;
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            } );
    }

    // region #Start Member Function Section
    /**
     * On Member Details Search
     */
    searchMember() {
        this.isWhosaleCheckNotCalculated = false;
        this.isMemberHasAccessToOrder = true;
        this.searchReqValues = this.posOrderFormGroup.getRawValue();
        this.paymentComponentSettings.savedCards = [];
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        let fboId = this.searchReqValues.memberInfo;
        if (new RegExp(distributorIdPattern).test(this.searchReqValues.memberInfo)) {
            fboId = fboId.replace(/-|\s/g, '');
        }
        this.memberSearchSubmitted = true;
        this.memberInfo = null;
        if (this.posOrderFormGroup.value.memberInfo && this.posOrderFormGroup.value.memberInfo.length > 0) {
            this.getMemberInfo(fboId);
        }
    }

    /**
     * Get Member Info by EmailID or FBOID
     */
    getMemberInfo(memberDetails: string) {
       // this.posOrderFormGroup.controls['posLocation'].disable();
       this.memberDiscountPercentage = null;
        let type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this._orderService.getMemberInfo(memberDetails, type).subscribe(response => {
            if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                this.posOrderFormGroup.controls['posLocation'].enable();
            }
            if (response && response.memberId) {
                const fboId =response.fboId;
                const firstName =response.firstName;
                const lastName =response.lastName;
                const memberlevel = this._commonService.getMemberLevel(response.memberLevelID);
                this._commonService.getMemberStatus(fboId).subscribe(accountInfo => {
                    if(accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                        this.accountRestriction = true;
                        const memberDetails = {
                            fboId: fboId,
                            firstName: firstName,
                            lastName: lastName,
                            memberLevel: memberlevel
                        };
                        this.memberDetails = memberDetails;
                        this.isPaymentBlockEnabled = true;
                    } else {
                        this.getMemberInformation(response);
                    }
                })
            } else {
                if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                    this.posOrderFormGroup.controls['posLocation'].enable();
                }
                this.clearAllTheForms();
                const notification: any = this._translatePipe.get('order.Member Details Not Found');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        }, error => {
            if (this.posLocations && this.posLocations.length && this.posLocations.length > 1) {
                this.posOrderFormGroup.controls['posLocation'].enable();
            }
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Details');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        });
    }

    closeModal(status: boolean){
        this.accountRestriction = status;
    }

    getMemberInformation(response){
        this.storeInfo = null;
        if (response && response.memberContacts) {
        const mobileNumber = response.memberContacts.find(x => (x.contactTypeID === ContactType.Mobile));
        const phoneNumber = response.memberContacts.find(x => (x.contactTypeID === ContactType.Phone));
         this.memberInfo = {
              mobile: mobileNumber && mobileNumber != 0 ? mobileNumber : null,
              phone: phoneNumber && phoneNumber !=0 ? phoneNumber : null
             };
        const defaultPhone = mobileNumber || phoneNumber;
          if (defaultPhone) {
            this.memberInfo.phone = defaultPhone.value;
             this.memberInfo.phoneType = defaultPhone.contactTypeID;
            }
        }
        this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
        // Add Validation for Member Level
        this.getMemberLevelInfo(response);
    }
    getMemberLevelInfo(memberResponse): void {
      this.processMemberResponse(memberResponse);
        // this.posOrderFormGroup.controls['posLocation'].disable();
        // this._commonService.getMemberLevelDetails(memberResponse.fboId).subscribe((response) => {
        //     this.posOrderFormGroup.controls['posLocation'].enable();
        //     if (response) {
        //         memberResponse.memberTitle = response.memberLevel;
        //         if (+memberResponse.memberTypeId === this.memberTypeEnum.FPC) {
        //             memberResponse.memberTitle = MemberType.PREFERREDCUSTOMER;
        //         }
        //     }
        //     this.processMemberResponse(memberResponse);
        // }, (error) => {
        //     this.posOrderFormGroup.controls['posLocation'].enable();
        //     this.processMemberResponse(memberResponse);
        // });
    }

    processMemberResponse(response): void {
        this.isMemberEligibleToPlaceOrder = false;
        const notification: any = this._translatePipe.get('order.Member Details Found');
        this.memberTypeNotification = this._translatePipe.get('order.This member is not allowed to place pos order in this location');
        this.memberInfo = response;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === this.memberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        } else if (+response.memberTypeId === this.memberTypeEnum.FPC || this.memberInfo.memberTitleId ===MemberLevel.PREFERREDCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if(this.memberInfo && this.memberInfo.memberTypeId ===this.memberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId===MemberLevel.NOVICCUSTOMER){
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (+response.memberTypeId !== this.memberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        if(response.memberTypeId == MemberTypeEnum.DISTRIBUTOR){
            this.getMembergovernmentIdentificationsInfo(response.memberId);
        }
        this.orderTaxResponse = null;
        this.memberStatus = response.memberStatus;
        if (this.memberStatus && this.memberStatus.id) {
            this.isActive = (this.memberStatus.id === +MemberStatus.Active);
        } else {
            this.isActive = false;
        }
        console.log("this.isActive",this.isActive);
        if (response.memberTitleId && response.memberTypeId && (+response.memberTypeId === this.memberTypeEnum.GUEST)){
                this.isMemberEligibleToPlaceOrder = true;
                this._commonService.createNotification('', this.memberTypeNotification.value, 'error');
        }
        this.memberSearchSubmitted = false;
        this.memberTypeId = this.memberInfo.memberTypeId;
        this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.getMailingAddress(this.memberInfo);
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.paymentComponentSettings.distributorId = this.memberInfo.fboId;
        this.paymentComponentSettings.uniqueRefId = this.memberInfo.uniqueRefID? this.memberInfo.uniqueRefID : '';
        const memberTitleID = this._orderService.getMemberTitleId(this.memberInfo);
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(memberTitleID);
        if(this.orderSession){
            this.getPosLocations();
        }
        else{
            this.clearAllTheForms();
            this.orderSession=null;
        }
    }

    loadMemberBasicInfo(memberId: number) {
        if (memberId && !this.businessEntityId) {
            this._customerService.getMemberBasicInfoById(memberId)
                .subscribe((res) => {
                    if (res && res.businessEntities) {
                        const activeBusinessEntity: FBOBusinessEntity = res.businessEntities.find((entity: FBOBusinessEntity) => entity.status === RowStatus.Active && entity.countryCodeId);
                        if(activeBusinessEntity)
                        {
                        const country = this.countries && this.countries.find((country) => country.countryId && country.countryId === activeBusinessEntity.countryCodeId);
                        if (activeBusinessEntity && country.isocodeThree.toLowerCase() === this.countryCode.toLowerCase()) {
                           if(this._orderService.isValidDate(activeBusinessEntity.startDate,activeBusinessEntity.endDate)){
                               this.businessEntityId = activeBusinessEntity.id;
                           } else {
                               this.businessEntityId = null;
                           }
                        }
                    }
                }
                },
                    (error) => { }
                );
        }
    }

    /**
     * Get wholesale qualified details for a FPC / FBO based on memberID and countryCode
     * @param memberID
     * @param countryCode
     */

    private getWholsesaleQualifiedDetails(fboId: string, memberHomeCountry: string, storeInfo: StoreConfig) {
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe((res: WholesaleQualifiedResponse) => {
                try {
                    if (res) {
                        this.isWhosaleCheckNotCalculated = false;
                        if (res && res.error) {
                            this.wholesaleCheckErrorNotifications();
                        }
                        this.memberInfo.optin = res.optIn ? res.optIn : false;
                        this.memberInfo.wholeSaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                        // Member wholesale qualified eligibility check
                        this.memberInfo.transactionalWholesaleQualified = res.wholesaleQualified ? res.wholesaleQualified : false;
                        this.memberInfo.transactionalOptin = res.optIn ? res.optIn : false;

                        let balance;
                        try {
                            balance = Number(res.balance);
                        } catch {
                            balance = this.distributorMaxCC;
                        }
                        if (!balance) {
                            balance = this.distributorMaxCC;
                        }
                        this.getMemberDiscountPercentages(storeInfo);
                    }
                } catch (error) {
                    this.getMemberDiscountPercentages(storeInfo);
                    this.wholesaleCheckErrorNotifications();
                }
            }, error => {
                this.getMemberDiscountPercentages(storeInfo);
                this.wholesaleCheckErrorNotifications();
            });
    }

    wholesaleCheckErrorNotifications() {
        this.isWhosaleCheckNotCalculated = true;
        let notification: any = this._translatePipe.get('order.The order is not receiving the PC Wholesale response from Valence. Please try again later.');
        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
    }

    /**
     * map the billing address fields
     */
    mapBillingAddress() {
        if (this.memberInfo && this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId === this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo = country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }

    }

    /** Products
    * @returns Products
    */
    private getProductModels(): ShippingProductModel[] {
        // const items: any = this.posOrderFormGroup.get('items');
        const productModels: ShippingProductModel[] = [];
        if (this.products && this.products.length > 0) {

            for (let index = 0; index < this.products.length; index++) {

                const product = this.products[index];
                // const quantity = items.controls[index].controls['quantity'].value;
                if (product) {
                    const productModel: ShippingProductModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }

            }

        }
        return productModels;
    }

    // endregion

    // region #Start Products Section
    /**
    * @param  {any} data
    * @returns SafeHtml
    */
    autocompleListFormatter = (data: any): SafeHtml => {

        const html = `<span>${data.itemNumber} - ${this._titleCase.transform(data.displayName ? data.displayName : data.name)}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
     * Auto Complete Product Search
     */
    observableSource = (keyword: any, fullSearch?: boolean): Observable<any[]> => {
        let fpc5PercentEnabled = false;
        if (this.memberInfo && this.storeInfo) {
            if (keyword && keyword.length > 1) {
                if (keyword.indexOf('#') == 0) {
                    keyword = keyword.replace(/#/, '');
                }
                if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
                    fpc5PercentEnabled = true;
                }
                let wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified ? true : false;
                if (wholesaleQualified == null) {
                    wholesaleQualified = false;
                }
                const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
                let memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
                this.purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled,false,memberTitleId);
                // HARD_DOWNGRADE CHECK FOR FPC USERS
                if (this.memberInfo) {
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                }
                let _itemNumberURL = environment.productsUrl + '/stores/' + this.storeInfo.id + '/customerservice/products' +
                    '?languageCode=' + this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId +
                    '&countryCode=' + this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                    + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&source=' + ProductSource.ADMINISTRATION +
                    '&optin=' + optin + '&taxInclusive=' + this.storeInfo.taxInclusive;
                if (fullSearch) {
                    _itemNumberURL += '&searchType=FULL';
                }
                return this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(res => {
                    const results = res.json();
                    if (results && results.length > 0) {
                        return results;
                    } else {
                        return [];
                    }
                });
            } else {
                return Observable.of([]);
            }
        } else {
            let notification: any;
            if (!this.memberInfo) {
                notification = this._translatePipe.get('order.Member Details are Mandatory');
            }
           else if (!this.storeInfo && this.showPOSOrderValidation) {
                notification = this._translatePipe.get('order.Member not eligible for POS orders');
            }
            else if(!this.storeInfo) {
                notification = this._translatePipe.get('order.Please select POS Location');
            }
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    }
    /**
     * Decrement the item Quantity
     * @returns void
     */
    decrementQuantity(index: number): void {
        this.disableQty = true;
        const items: any = this.posOrderFormGroup.get('items');
        const productid=items.value[index].productId;
        let productids: number[] = [];
        productids.push(productid);
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
        .subscribe(response => {
            this.productwareHouseLocation = response;
            if (this.productwareHouseLocation && this.productwareHouseLocation.length > 0) {
                if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity > 0) {
                    if(+items.value[index].quantity - 1 <= this.productwareHouseLocation[0].stockQuantity){
                        this.decrementQuantityAndUpdateCart(index);
                    }else{
                        let addedNotification: any = 'can not add product ' + items.value[index].productName+ ' Avalible Quantity '+this.productwareHouseLocation[0].stockQuantity;
                        if(this.taxCalculationStatus){
                            this.taxCalculationStatus = false;
                        }
                        this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                        this.disableQty = false;
                    }
                }
                if(this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity <= 0){
                    if(this.taxCalculationStatus){
                        this.taxCalculationStatus = false;
                    }
                    let addedNotification: any = 'can not add product ' + items.value[index].productName+ ' Avalible Quantity 0';
                    this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                }
                if (!this.productwareHouseLocation[0].manageStock) {
                    this.decrementQuantityAndUpdateCart(index);
                }
            }
            if (this.productwareHouseLocation && this.productwareHouseLocation.length == 0) {
                this.decrementQuantityAndUpdateCart(index);
            }
        });
        console.log("decrementQuantity taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    }

    decrementQuantityAndUpdateCart(index: number): void{
        this.taxCalculationStatus = true;
        const items: any = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            this.setFocusbyID('quantity-' + (index));
            const sameProductIndex = this.getDepositFeeProductIndex(items,index);
            if(sameProductIndex >= 0){
                this.decrementQuantityAndUpdateCart(sameProductIndex);
            }
            this.updateTotalsAndShipMethod();
            this.getHandlingFeeCharges();
        }
        console.log("decrementQuantityAndUpdateCart taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    }

    getDepositFeeProductIndex(items: any, index: number): number {
        if(this.productAssociationInfo){
            const productid=items.value[index].productId;
            const associateProduct = this.productAssociationInfo.find(x => x.productId === productid);
            if(associateProduct){
                const sameProductIndex = items.controls.findIndex(item => item.controls['productId'].value === associateProduct.depositFeeProductId);
                return sameProductIndex;
            }
            return;
        }
    }
    /**
    * Increment the item Quantity
    * @returns void
    */
    incrementQuantity(index: number): void {
        this.disableQty = true;
        const items: any = this.posOrderFormGroup.get('items');
        const productid=items.value[index].productId;
        let productids: number[] = [];
        productids.push(productid);
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
        .subscribe(response => {
            this.productwareHouseLocation = response;
            if (this.productwareHouseLocation && this.productwareHouseLocation.length > 0) {
                if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity > 0) {
                    if(+items.value[index].quantity + 1 <= this.productwareHouseLocation[0].stockQuantity){
                        this.incrementQuantityandAddtoCart(index);
                    }else{
                        let addedNotification: any = 'can not add product ' +items.value[index].productName+' Avalible Quantity '+this.productwareHouseLocation[0].stockQuantity;
                        if(this.taxCalculationStatus){
                            this.taxCalculationStatus = false;
                        }
                        this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                        this.disableQty = false;
                    }
                }
                if(this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity == 0){
                    if(this.taxCalculationStatus){
                        this.taxCalculationStatus = false;
                    }
                    let addedNotification: any = 'can not add product ' +items.value[index].productName+' Avalible Quantity 0';
                    this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                }
                if (!this.productwareHouseLocation[0].manageStock) {
                    this.incrementQuantityandAddtoCart(index);
                }
            }
            if (this.productwareHouseLocation && this.productwareHouseLocation.length == 0) {
                this.incrementQuantityandAddtoCart(index);
            }
        });
        console.log("incrementQuantity taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    }
    incrementQuantityandAddtoCart(index:number):void{
        this.taxCalculationStatus = true;
        const items: any = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            const product = items.controls[index].controls['productItem'].value;
            // //if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock) && !(product.stockAvailable && !product.manageStock)) {
            // if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock)) {
            //     items.controls[index].controls['quantity'].setValue(product.stockQuantity);
            //     const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
            //     this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);

            //     items.controls[index].controls['disableIncrement'].setValue(true);
            // } else {
            //     items.controls[index].controls['disableIncrement'].setValue(false);
            // }
            // items.controls[index].controls['disableIncrement'].setValue(false);
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.setFocusbyID('quantity-' + (index));
            const sameProductIndex = this.getDepositFeeProductIndex(items,index);
            if(sameProductIndex >= 0){
                this.incrementQuantityandAddtoCart(sameProductIndex);
            }
            this.updateTotalsAndShipMethod();
            this.getHandlingFeeCharges();
        }
        console.log("incrementQuantityandAddtoCart taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    }


    quantityChange(event: any, index: number) {
        const items: any = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    }
    setPreviousQuantity(value:number){
        this.previousQuantity = value;
    }
    /**
    * @param  {number} index
    * @returns void
    */
    updateQuantity(event: any, index: number): void {
        const items: any = this.posOrderFormGroup.get('items');
        const productid=items.value[index].productId;
        let productids: number[] = [];
        productids.push(productid);
        let quantity = event.target ? +event.target.value : event;
        this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
        .subscribe(response => {
            this.productwareHouseLocation = response;
            if (this.productwareHouseLocation && this.productwareHouseLocation.length > 0) {
                if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity > 0) {
                    if(quantity<= this.productwareHouseLocation[0].stockQuantity){
                        this.cartLimitNotReach = false;
                        this.updateQuantityAndAddtoCart(quantity,index);

                    }else{
                        items.controls[index].controls['quantity'].setValue(this.previousQuantity);
                        if(this.taxCalculationStatus){
                            this.taxCalculationStatus = false;
                        }
                        let addedNotification: any = 'can not add product ' +items.value[index].productName+' Avalible Quantity '+this.productwareHouseLocation[0].stockQuantity;
                        this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                    }
                }
                if(this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity <= 0){
                    if(this.taxCalculationStatus){
                        this.taxCalculationStatus = false;
                    }
                    items.controls[index].controls['quantity'].setValue(this.previousQuantity);
                    let addedNotification: any = 'can not add product ' +items.value[index].productName+' Avalible Quantity 0';
                    this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                }
                if (!this.productwareHouseLocation[0].manageStock) {
                    this.updateQuantityAndAddtoCart(quantity,index);
                }
            }
            if (this.productwareHouseLocation && this.productwareHouseLocation.length == 0) {
                this.updateQuantityAndAddtoCart(quantity,index);
            }
        });   
        console.log("updateQuantity taxCalculationStatus ",this.taxCalculationStatus);     
    }


    updateQuantityAndAddtoCart(quantity: any, index: number): void {
        if (!this.isRestrictionPopupOpened && !this.addNewCardClicked) {
            const items: any = this.posOrderFormGroup.get('items');
            if (items && items.length > 0 && this.storeInfo) {
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (quantity && parseInt(quantity, 10))) {
                    const product = items.controls[index].controls['productItem'].value;
                    items.controls[index].controls['quantity'].setValue((quantity));
                    // if (product && event.target.value > product.stockQuantity && product.manageStock) {
                    //     items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                    //     const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                    //     this._commonService.createNotification('', cartStockErrors.value, NotificationType.ERROR);
                    //     items.controls[index].controls['disableIncrement'].setValue(true);
                    // } else {
                    //     items.controls[index].controls['quantity'].setValue(event.target.value);
                    //     items.controls[index].controls['disableIncrement'].setValue(false);
                    // }
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                const sameProductIndex = this.getDepositFeeProductIndex(items, index);
                if (sameProductIndex >= 0) {
                    let depositFeeProductQuantity = +items.value[sameProductIndex].quantity;
                    depositFeeProductQuantity = depositFeeProductQuantity - this.previousQuantity;
                    depositFeeProductQuantity = depositFeeProductQuantity + quantity;
                    if (depositFeeProductQuantity >= 0) {
                        this.updateQuantityAndAddtoCart(depositFeeProductQuantity, sameProductIndex);
                    }
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod();
                }
                if (this.isQuantityUpdate) {
                    this.getHandlingFeeCharges();
                }

                this.isFocused = false;
            }
        }
    }


    /**
     * disabling Submit button
     */
    disableSubmitButton(): void {
        this.taxCalculationStatus = true;
    }

    /**
     * @returns void
     */
    deleteItem(index: number): void {
        const items = this.posOrderFormGroup.get('items') as any;
        const productQuantity = +items.controls[index].controls['quantity'].value;
        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                const depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                let productId = items.value[index].productId;
                const parentProduct = this.productAssociationInfo.find(x => x.productId === productId);
                if (parentProduct) {
                    // remove the parent product
                    items.removeAt(index);
                    const depositFeeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === parentProduct.depositFeeProductId);
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            let depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity
                                items.setValue(items.value);
                            } else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    } else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                } else {
                    items.removeAt(index);
                }
            } else {
                items.removeAt(index);
            }
        }
        setTimeout(() => {
            if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                this.itemLevelSearch.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod();
        this.getHandlingFeeCharges();
    }

    addItemNumber(): void {
        this.items = this.posOrderFormGroup.get('items') as any;
        this.items.push(this.createItemNumberGroup());
    }

    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    public clearAllTheForms(clearMember: boolean = false) {        
        this.paymentComponentSettings.webOrderId = '';
        this.selectedpayvisionCardInfo = null;
        this.bankDetailsList = [];
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        //this.shippingTax = 0;
        this.handlingCharges = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.memberLevelHistory = [];
        this.orderSubmitted = false;
        this.posOrderFormGroup.get('items').reset();
        this.orderSession=null;
        const arr = <FormArray>this.posOrderFormGroup.controls.items;
        arr.controls = [];
        this.businessEntityId = null;
        this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
        if (clearMember) {
            this.posOrderFormGroup.controls['posLocation'].setValue('');
            this.posOrderFormGroup.controls['posLocation'].updateValueAndValidity();
            this.posOrderFormGroup.controls['memberInfo'].setValidators([Validators.required]);
            this.posOrderFormGroup.controls['memberInfo'].updateValueAndValidity();
            this.posOrderFormGroup.controls['memberInfo'].setValue('');
            this.memberInfo = null;
            this.orderFromLookup = false;
        }
        this.posOrderFormGroup.controls['itemSearch'].setValue('');
        this.posOrderFormGroup.controls['backDateOrder'].setValue(false);
        this.posOrderFormGroup.markAsUntouched();
        this.updateTotalsAndShipMethod();
        this.orderTaxResponse = null;
        if(!this.orderSession){
            this.assignDefaultLocation();
            this.products = [];
        }
        this.isEnterPaymentDetailsEnabled = false;
        this.isPaymentBlockEnabled = false;
        if(this.externalPaymentForm && this.externalPaymentForm.get('payments')){
            this.externalPaymentForm.get('payments').reset();
        }
        if(this.splitPaymentForm && this.splitPaymentForm.get('payments')){
            this.splitPaymentForm.get('payments').reset();
        }
        this.placeOrderClicked = false;
        this.splitPayments= [];
        this.balanceOrderTotal= null;
        this.posPaymentMethods = [];
        this.posPaymentGroups = [];
        this.productAssociationInfo = [];
        this.depsoitFeeProductsInfo =[];
        this.isOverrideMinimumLimit=false;
        this.terminalDetails = null;
        this.isTerminalSelected = false;
        this.enablePaymentBlock(false);
    }
    clearOnPosLocationChange(){
    this.paymentComponentSettings.webOrderId = '';
    this.selectedpayvisionCardInfo = null;
    this.bankDetailsList = [];
    this.subTotal = 0;
    this.retailSubTotal = 0.0;
    //this.shippingTax = 0;
    this.handlingCharges = 0;
    this.importFeeValue = 0;
    this.taxableAmount = 0;
    this.orderTaxResponse = null;
    this.products = [];
    this.totalCommissionableVolume = 0;
    this.shoppingCartCount = 0;
    this.memberLevelHistory = [];
    this.orderSubmitted = false;
    this.posOrderFormGroup.get('items').reset();
    this.orderSession=null;
    const arr = <FormArray>this.posOrderFormGroup.controls.items;
    arr.controls = [];
    this.businessEntityId = null;
    this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
    this.posOrderFormGroup.controls['itemSearch'].setValue('');
    this.posOrderFormGroup.controls['backDateOrder'].setValue(false);
    // this.posOrderFormGroup.markAsUntouched();
    this.updateTotalsAndShipMethod();
    this.orderTaxResponse = null;
    if(!this.orderSession){
        this.products = [];
    }
    this.isEnterPaymentDetailsEnabled = false;
    this.isPaymentBlockEnabled = false;
    if(this.externalPaymentForm && this.externalPaymentForm.get('payments')){
        this.externalPaymentForm.get('payments').reset();
    }
    if(this.splitPaymentForm && this.splitPaymentForm.get('payments')){
        this.splitPaymentForm.get('payments').reset();
    }
    this.placeOrderClicked = false;
    this.splitPayments= [];
    this.balanceOrderTotal= null;
    this.posPaymentMethods = [];
    this.posPaymentGroups = [];
    this.productAssociationInfo = [];
    this.depsoitFeeProductsInfo =[];
    this.isOverrideMinimumLimit=false;
    this.terminalDetails = null;
    this.isTerminalSelected = false;
}
    /**
     * update Totals and ShipMethod
     */
    updateTotalsAndShipMethod() {
        this.subTotal = 0;
        this.retailSubTotal = 0;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        const items: any = this.posOrderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo) {
            for (let index = 0; index < items.length; index++) {
                const product = items.controls[index].controls['productItem'].value;
                const quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    const existProduct = this.products.filter(productObj => productObj.id === product.id)[0];
                    if (!existProduct) {
                        product.quantity = quantity;
                        this.products.push(product);
                    } else {
                        const productIndex = this.products.findIndex(item => item.id === existProduct.id);
                        this.products[productIndex].quantity = this.products[productIndex].quantity + quantity;
                    }
                    const address = this.getPickUpAddress();
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                const country = this.countries.find(x => x.countryId === address.countryId);
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }
                    const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
                    const taxCalculated = this.appConfig.displayTaxInclusivePrice ? false : true;
                    this.displayPriceConfig = this._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this.storeInfo.taxInclusive,
                            this.memberInfo, taxCalculated, this.countryTaxInclusive, this.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    let retailPrice: number = product.retailPrice;
                    if (this.displayPriceConfig) {
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            (this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice);
                    }
                    this.subTotal = this.subTotal + this.getItemTotalSum(product);
                    this.retailSubTotal = this.retailSubTotal + (retailPrice * +quantity);
                    this.totalCommissionableVolume = this.totalCommissionableVolume + (product.commissionableVolume * +quantity);
                    this.shoppingCartCount += +product.quantity;
                }
            }
            if (this.orderRules && this.orderRules.valueType === ValueType.PRICE && !(this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                const subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
                const literatureItems = this.getLiteratureItems(this.products);
                if (this.isMemberFboUpgraded) {
                    this.upgradeFboLimitExceeded = this.validateMemberMonthlyAmountLimit(subTotal);
                    if (this.upgradeFboLimitExceeded) {
                        this.checkMemberAccess();
                        return;
                    } else {
                        this.isMemberHasAccessToOrder = true;
                    }
                }
                if (!((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                    || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                        && subTotal <= this.orderRules.maxValue))) {
                    if (this.appConfig.orderMinMaxPriceValidation) {
                        this.minMaxPriceValidation = true;
                    }
                    if (subTotal > this.orderRules.maxValue) {
                        clearTimeout(this.cartMessageID);
                        const cartValueExceeded: any = this._translatePipe.get('order.Your cart must not exceed');
                        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
                        const cartValueExceededNotification: any = cartValueExceeded.value + ' <b class="helvetica-bold">' +
                            maxValue + '</b>';
                        if (this.appConfig && this.appConfig.displayPurchaseLimitationMessage) {

                            this.cartMessageID = setTimeout(() => {
                                this._commonService.createNotification('', cartValueExceededNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                            }, 100);
                        }
                        this.cartLimitExceed = true;
                    } else if (subTotal < this.orderRules.minValue && !this.isOverrideMinimumLimit) {
                        clearTimeout(this.cartMessageID);
                        let cartMinimumLimit: any = this._translatePipe.get('order.Order must meet a minimum of');
                        if (this.products && this.products.length &&
                            this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR
                            && this.appConfig.displayPurchaseLimitationMessage
                            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                            cartMinimumLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                        }
                        if(this.overrideMinimumLimitIsEnabled){
                            let overrideLimitLink:any=this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                            let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                            const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                            minValue + '</b>.<b>'+overrideLimitLink.value+'</b>';
                            this.cartMessageID = setTimeout(() => {
                                const toast=this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                                toast.click.subscribe((event) => {
                                    if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                        this.overrideMinimumLimit.open();
                                    }
                                });
                            }, 100);
                            this.cartLimitNotReach=false;
                        }
                       else{
                        let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                            const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                            minValue + '</b>';
                            this.cartMessageID = setTimeout(() => {
                                this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
                            }, 100);
                        }
                        this.cartLimitNotReach = true;

                    } else {
                        this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                        this._commonService.removeNotification(Constants.MIN_LIMIT);
                    }
                } else {
                    this.cartLimitExceed = false;
                    this.cartLimitNotReach = false;
                    this.minMaxPriceValidation = false;
                }
            }
        }
    }


    getOverrideMinimumLimit():boolean{
        if(this.userInfo && this.userInfo.allowedOperatingCountries && this.storeInfo && this.storeInfo.operatingCountry && !this.userInfo.hasSystemRole && this.operatingCountry){
            let isoCodeThree:any=this.storeInfo.operatingCountry;
            let allowedCountryIds:any=[];
            let operatingCountryId=this.operatingCountry.filter(operatingCountry=>operatingCountry.value==isoCodeThree);
            allowedCountryIds=this.userInfo.allowedOperatingCountries.split(",");
            if(operatingCountryId && operatingCountryId.length>0){
                return allowedCountryIds.includes(operatingCountryId[0].id.toString()) && this.hasMinimumOverrideLimit;
            }
            else{
                return false;
            }
        }
        return this.userInfo && this.userInfo.hasSystemRole===true?true:false;

    }

    getOperatingCountries():void{
        this._customerService.getOperatingCountries().subscribe((response:any)=>{
            if(response){
                this.operatingCountry=response;
            }
        },err=>{
            console.log(err)
        });

    }

    closeOverrideMinimumLimit():void{
        this.isOverrideMinimumLimit=false;
        this.overrideMinimumLimit.close();
    }

    overrideMinimumLimitValueCheck(event:any){
        this.isOverrideMinimumLimit=event.currentTarget.checked;
    }


    closeNotification():void{
        this.isOverrideMinimumLimit===true?this.enablePaymentBlock(true):this.enablePaymentBlock(false);
        if(this.isOverrideMinimumLimit===true){
            this.createOrder();
            this.cartLimitNotReach = false;
        }
        this._commonService.removeNotification(Constants.MIN_LIMIT);
        this._commonService.removeNotification(Constants.ORDER_LIMIT);
        this.overrideMinimumLimit.close();
    }


    /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
    calculateSubtotalWithWholesalePrice(orderSubTotal: number): number {
        let subTotal = orderSubTotal;
        if (this.products && this.products.length &&
            this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR
            && this.appConfig.displayPurchaseLimitationMessage
            && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
            subTotal = 0;
            this.products.forEach(item => {
                subTotal += ((this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
            });
            // Should not apply wholesale price when user exceeds limit,
            // Wholesale price calculation applicable for minimum limit restriction
            if (orderSubTotal > this.orderRules.maxValue) {
                subTotal = orderSubTotal;
            }
        }
        return subTotal;
    }

/**
 * Selected Shipping Address
 */
    getBillingAddress(): any {
        let countryId = 0;
        if (this.countries && !this.billingAddressInfo.countryId) {
            let billingCountry: Country;
            if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length > 2) {
                billingCountry =
                    this.countries.find((x: any) => x.isocodeThree.toLowerCase()
                        === this.billingAddressInfo.countryCode.toLowerCase());
            } else if (this.billingAddressInfo.countryCode && this.billingAddressInfo.countryCode.length === 2) {
                billingCountry =
                    this.countries.find((x: any) => x.isocodeTwo.toLowerCase()
                        === this.billingAddressInfo.countryCode.toLowerCase());
            }
            if (billingCountry) {
                countryId = billingCountry.countryId;
            }
        }
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress: any = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode,
            country: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    }
    getPickUpAddress(): any {
        if (this.shipMethod && this.shipMethod.pickUpLocation) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;

            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);

            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            return this.shipMethod.pickUpLocation;
        } else {
            return null;
        }
    }

    /**
     * Store Ware house Address
     */
    getWarehouseAddress(): Address {
        let warehouseAddress: Address = null;
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            warehouseAddress = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                country: this.storeInfo.warehouseAddress.countryCode || this.selectedIsoCountryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: null
            };
        }
        return warehouseAddress;
    }

    /**
     * verifyOrderRules
     * @returns boolean
     */
    verifyOrderRules(isBackOrderDate: boolean): any {
        let valid: any;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false, cartLimitExceed: false, cartLimitNotReach: false, purchaseLimitExceed: false };
        let monthlyCCValid = false;
        let thresholdCrossed = false;
        const totalPoints = this.calculateTotalPoints();
        const subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        const literatureItems = this.getLiteratureItems(this.products);
        valid.purchaseLimitExceed = this.validateMemberMonthlyAmountLimit(totalPoints);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
            thresholdCrossed = false;
        } else if ((this.orderRules && this.orderRules.valueType === ValueType.PRICE) && (this.checkoutConfig.enableMinAndMaxLimitRules||this.checkoutConfig.enablePosOrderValidation)) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
                if (subTotal > this.orderRules.maxValue && this.isPaymentBlockEnabled) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue && this.isPaymentBlockEnabled) {
                    this.isOverrideMinimumLimit===true?valid.cartLimitNotReach=false:valid.cartLimitNotReach=true;
                }
            } else if ((subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue)
                || (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                    && subTotal <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
            } else if((this.isOverrideMinimumLimit && subTotal<=this.orderRules.maxValue)||
                (this.orderRules.includeLiterature && literatureItems && literatureItems.length === this.products.length
                && subTotal <= this.orderRules.maxValue)){
                thresholdCrossed=false;
                if (this.isOverrideMinimumLimit) {
                    valid.cartLimitNotReach = false;
                }
            }
            else {
                thresholdCrossed = true;
                if (subTotal > this.orderRules.maxValue) {
                    valid.cartLimitExceed = true;
                } else if (subTotal < this.orderRules.minValue) {
                    valid.cartLimitNotReach = true;
                }
            }
        } else {
            if(this.checkoutConfig.enableMinAndMaxLimitRules||this.checkoutConfig.enablePosOrderValidation){
                thresholdCrossed = true;
                if ((this.orderRules && this.orderRules.valueType === ValueType.PRICE)) {
                    if (subTotal > this.orderRules.maxValue) {
                        valid.cartLimitExceed = true;
                    } else if (subTotal < this.orderRules.minValue) {
                        valid.cartLimitNotReach = true;
                    }
                }
            }
        }
        if (this.memberInfo && this.memberOrderCCInfo) {
            let maxValue;
            if (!this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
            } else {
                maxValue = this.orderRules && this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                    ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
            }

            if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                monthlyCCValid = true;
                thresholdCrossed = false;
            }

            // Monthly CC override for member
            if (this.memberCCOverride && this.memberCCOverride.overrideFlag) {
                const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                const endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                if (!isBackOrderDate) {
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        valid.memberCCOverride = true;
                    } else if ((this.orderRules && this.orderRules.maxValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                        monthlyCCValid = false;
                    }
                } else {
                    const createdDate = this.momentConstructor(this.memberCCOverride.effectiveStartDate)
                        .format(DateConstants.DateFormat);
                    if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        valid.memberCCOverride = true;
                    } else if ((this.orderRules.maxValue < this.memberCCOverride.cVLimit) &&
                        ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(createdDate).getMonth() + 1 <= new Date().getMonth())) {
                        monthlyCCValid = false;
                    }
                }
            }
        }
        if (!totalPoints) {
            monthlyCCValid = false;
        }
        valid.thresholdCrossed = thresholdCrossed;
        valid.monthlyCCValid = monthlyCCValid;
        // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            let details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
            );
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
        return valid;
    }

    getLiteratureItems(products: any[]): any[] {
        let literatureItems;
        if (products && products.length) {
            literatureItems = products.filter(item => item.literature);
            if (this.orderRules && this.orderRules.itemNumbers && this.orderRules.itemNumbers.length) {
                const tripackItems = products.filter(item => this.orderRules.itemNumbers.indexOf(+item.itemNumber) > -1);
                if (tripackItems && tripackItems.length) {
                    literatureItems.push(tripackItems);
                }
            }
        }
        return literatureItems;
    }

    validateMemberMonthlyAmountLimit(totalPoints): boolean {
        let purchaseLimitExceed = false;
        const memberOrderRules: MemberOrderCCInfo = this.memberOrderCCInfo;
        if (this.orderRules && this.orderRules.valueType === ValueType.PRICE
            && memberOrderRules && (totalPoints + memberOrderRules.actualTotalValue) > this.orderRules.maxValue) {
            purchaseLimitExceed = true;
        }
        return purchaseLimitExceed;
    }


    getMailingAddress(memberInfo: any) {
        let billingAddress: any = {}
        billingAddress = {
            firstName: memberInfo.firstName,
            lastName: memberInfo.lastname,
            addressLine1: memberInfo.address.addressLine1,
            addressLine2: memberInfo.address.addressLine2,
            city: memberInfo.address.city,
            id: memberInfo.address.id,
            addressType: memberInfo.address.addressTypeId,
            postalCode: memberInfo.address.zipCode,
            zip: memberInfo.address.zipCode,
            country: memberInfo.address.countryCodeTwo,
            countryCode: memberInfo.address.countryCodeTwo,
            countryId: memberInfo.address.countryId,
            state: this.getStatesCodeByByStateId(memberInfo.address.stateId)
        };

        this.paymentBillingAddress = billingAddress;
    }
    /**
     * Get total points
     */
    calculateTotalPoints(): number {
        let _totalCV = 0;
        for (let i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
                _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    }

    /**
     * on click of checkout
     * @memberof CartComponent
     */
    createOrder(): void {
        this.displayTryAgain = false;
        if (this.isWhosaleCheckNotCalculated) {
            this.wholesaleCheckErrorNotifications();
            return;
        }
        this.enablePaymentBlock(true);
        this.posPaymentGroups=[];
        const items: any = this.posOrderFormGroup.get('items');
        let productids: number[] = [];
        items.value.forEach(element => {
            productids.push(element.productId);
        });
        this.posStockAvailabilityCheck(productids,+this.posOrderFormGroup.controls['posLocation'].value);
    }

    getPlaceOrderStatus() {
        let placeOrderDisabled = true;
        console.log("this.posOrderFormGroup.valid",this.posOrderFormGroup.valid);
        console.log("this.placeOrderClicked",this.placeOrderClicked);
        console.log("this.balanceOrderTotal",this.balanceOrderTotal);
        console.log("this.isPayByLinkValid",this.isPayByLinkValid);
        console.log("this.agreementCheckError",this.agreementCheckError);
        console.log("this.isPaymentBlockEnabled",this.isPaymentBlockEnabled);
        console.log("this.taxCalculationStatus",this.taxCalculationStatus);
        if (this.posOrderFormGroup.valid && !this.placeOrderClicked && this.isActive && (this.balanceOrderTotal === 0 ? true : false) && this.isPayByLinkValid && !this.agreementCheckError && this.isPaymentBlockEnabled && !this.taxCalculationStatus) {
            if (this.posOrderFormGroup.value.paymentSelector && +this.posOrderFormGroup.value.paymentSelector === PosPaymentGroupEnum.External_Payment) {
                if (this.externalPaymentForm.valid) {
                    placeOrderDisabled = false;
                }
            } else {
                placeOrderDisabled = false;
            }
        }
        console.log("placeOrderDisabled",placeOrderDisabled);
        return placeOrderDisabled;
    }

    proceedCreateOrder(): void {
        this.checkMemberAccess();
        this._cacheService.set(CacheKey.CARTUPDATED, 'true');
        if (this.isMemberHasAccessToOrder && !this.upgradeFboLimitExceeded) {
            this.isSubmitted = true;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (this.products && this.products.length) {
                const productIds = this.products.map((item: Product) => item.id);
                if (productIds && productIds.length) {
                    let memberTitleId = this.memberInfo && this.memberInfo.memberTitleId;
                    // HARD_DOWNGRADE CHECK FOR FPC USERS
                    memberTitleId = this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
                    this.submitOrder();
                }
            }
        }
    }
    /**
     * @description To check stock available
     * @date 2019-09-20
     * @param {Product[]} products
     * @returns {Product[]}
     * @memberof OrderPromotionComponent
     */
    stockAvailabilityCheck(products: Product[]): Product[] {
        const cartProducts: Product[] = this.products;
        if (cartProducts && products && products.length) {
            const noStockItems: Product[] = [];
            products.forEach((product: Product) => {
                const cartItem = cartProducts.find((item: Product) => item.id === product.id);
                //if (cartItem && !((product.stockAvailable && !product.manageStock) || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                if (cartItem && !(!product.manageStock || (product.manageStock && product.stockQuantity >= cartItem.quantity))) {
                    noStockItems.push(cartItem);
                }
            });
            return noStockItems;
        }
        return [];
    }

    posStockAvailabilityCheck(productIds: number[], posLocationid?: number, placePosOrder?:boolean): void {
        const noStockItems = [];
        if(posLocationid && posLocationid > 0 && productIds && productIds.length > 0){
            this._customerService.getProductsByLocation(posLocationid, productIds).subscribe(
                (response:any) => {
                    const posProducts = response;
                    if(posProducts && posProducts.length >0){
                        posProducts.forEach((pickUpProduct) => {
                            const cartProduct = this.posOrderFormGroup.value.items.find((product) => product.productId === pickUpProduct.productId);
                            if(cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity){
                                cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                                noStockItems.push(cartProduct);
                            }
                        });
                    }
                    this.outOfStockItems = noStockItems;
                    if (this.outOfStockItems && this.outOfStockItems.length > 0) {
                        this.outOfStockModal.open();
                        this.enablePaymentBlock(false);
                    } else {
                        if(placePosOrder){
                           this.createPosOrderUpdate();
                        }
                        else{
                        this.proceedCreateOrder();
                        }
                    }
                },
                (error:any) => {
                    this.enablePaymentBlock(false);
                    const errorMessage: any = this._translateService.get('common.Sorry, Something Went Wrong: Please try again later.');
                    this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                }
            );
        }
    }

    submitOrder(url?: string) {
        this.isSubmitted = true;
        let requestUrl = '';
        this.orderSubmitted = true;
        requestUrl = url || ApiUrlConstants.orderApiUrl + '/V1/orders';
        if (this.posOrderFormGroup.valid) {
            const isBackDateOrder: boolean = this.posOrderFormGroup.value.backDateOrder;
            this.getMemberOrderRules(this.memberInfo, isBackDateOrder, requestUrl);
        }
    }


    placeOrder(requestUrl: string): void {

        const exceedMonthlyCCPopup: any = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        const exceedMonthlyCCOverridePopup: any = this._translatePipe
            .get('order.Monthly CC limit reached');
        const orderRulesMaxValue =  ( this.orderRules && this.orderRules.maxValue ) ? this.orderRules.maxValue : ( this.orderRules && this.orderRules.literatureMaxValue ) ? this.orderRules.literatureMaxValue : null ;
        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors((this._commonService.validateNumberDecimalPoint(orderRulesMaxValue) ? orderRulesMaxValue : orderRulesMaxValue) + '.00' || '0',this.storeInfo);
        const exceedPerOrderCC: any = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.',
            { max: maxValue}) ;
        let minimumCartLimit: any = this._translatePipe.get('order.Order must meet a minimum of');
        const maximumCartLimit: any = this._translatePipe.get('order.Cart must not exceed');
        const currentCC = this.calculateTotalPoints();
        if (this.thresholdCrossed && this.orderRules && this.orderRules.valueType !== ValueType.BOTH) {
            if (this.cartLimitExceed) {
                const cartMaximumLimitNotification: any = maximumCartLimit.value + ' <b class="helvetica-bold">' +
                    maxValue + '</b>';
                if (this.memberTypeId !== this.memberTypeEnum.RETAIL && this.memberInfo.memberTypeId !== this.memberTypeEnum.GUEST) {
                    this._commonService.createNotification('', cartMaximumLimitNotification, NotificationType.ERROR, 0, Constants.MAX_EXCEEDED);
                }
                this.isSubmitted = false;
            } else if (this.cartLimitNotReach) {
                if (this.products && this.products.length &&
                    this.memberInfo && this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR
                    && this.appConfig.displayPurchaseLimitationMessage
                    && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
                    minimumCartLimit = this._translatePipe.get('order.Order must meet a minimum limit on wholesale price of');
                }
                if(this.overrideMinimumLimitIsEnabled){
                    let overrideLimitLink:any=this._translatePipe.get("order.To Override Minimum Limit,click <a id='more-options'>here</a>");
                    const cartMinimumLimit: any = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                    let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                    const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                    minValue + '</b>.<b>'+overrideLimitLink.value+'</b>';
                    this.cartMessageID = setTimeout(() => {
                        const toast=this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                        toast.click.subscribe((event) => {
                            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                                this.overrideMinimumLimit.open();
                            }
                        });
                    }, 100);
                }
               else{
                    const cartMinimumLimit: any = this._translatePipe.get('order.To register as an FBO the order must meet a minimum of');
                    let minValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.minValue,this.storeInfo);
                    const cartMinimumLimitNotification: any = cartMinimumLimit.value + ' <b class="helvetica-bold">' +
                    minValue + '</b>';
                    this.cartMessageID = setTimeout(() => {
                        this._commonService.createNotification('', cartMinimumLimitNotification, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                    }, 100);
                }
                this.isSubmitted = false;
            } else {
                this._commonService.removeNotification(Constants.MAX_EXCEEDED);
                this._commonService.removeNotification(Constants.MIN_LIMIT);
            }
        }
        if ((((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo))
            || (!currentCC && this.orderRules.valueType !== ValueType.BOTH)
        ) {
            this.submitPlaceOrder(requestUrl);
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded) {
            const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + this.monthlyCCValue + '</b>';
            if (this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                if (this.memberCCLimitExceeded) {
                    this.isPaymentBlockEnabled = false;
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR);
                }
                if (this.cartLimitExceed || this.cartLimitNotReach) {
                    let isLiteratureValidation = this.isLiteratureValidation(this.products);
                    let invalidProductPopup: any = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                        {
                            min: isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,
                            max: isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue
                        });
                    this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                    this.enablePaymentBlock(false);
                } else {
                    this._commonService.removeNotification(Constants.ORDER_LIMIT);
                }
            }  else if (!this.appConfig.displayPurchaseLimitationMessage) {
                if (this.memberTypeId !== this.memberTypeEnum.RETAIL && this.memberTypeId !== this.memberTypeEnum.GUEST) {
                    this._commonService.createNotification('', monthlyCCContent, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                } else {
                    this._commonService.createNotification('', exceedPerOrderCC.value, NotificationType.ERROR, 0, Constants.ORDER_LIMIT);
                }
            }
            this.isSubmitted = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            this._commonService.createNotification('', exceedMonthlyCCOverridePopup.value, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isSubmitted = false;
        } else {
            this._commonService.removeNotification(Constants.MIN_LIMIT);
        }
    }
    /**
     * @description
     * @date 2019-09-04
     * @memberof OrderPromotionComponent
     */
    submitPlaceOrder(requestUrl: string): void {
        const orderRequest: any = this.prepareOrderRequest();
        if ((orderRequest.taxMetaData && this.isTaxMetaDataAvailable) || (!orderRequest.taxMetaData && !this.isTaxMetaDataAvailable)) {
            const compareTaxValues = this.appConfig && this.appConfig.ignoreCompareTax ? true : this.compareTax(orderRequest);
            if (compareTaxValues) {
                this.comparePriceTier(orderRequest, requestUrl);
            } else {
                const notification: any = this._translatePipe.get('order.There is a mismatch in tax calculation. Please try again later.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
                this.enablePaymentBlock(false);
            }
        }
        else {
            const notification: any = this._translatePipe.get('order.Tax is not mapped. Please try again later.');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            this.isSubmitted = false;
        }
    }

    /**
     * @description compare tax
     * @date 2019-10-31
     * @param {Order} orderRequest
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    compareTax(orderRequest: Order): boolean {
        if (orderRequest && orderRequest.taxMetaData && orderRequest.taxMetaData.orderTaxCharges
            && orderRequest.taxMetaData.orderTaxCharges.length > 0) {
            let totalTaxAmount = 0;
            let totalTaxChargeBased = 0;
            orderRequest.taxMetaData.orderTaxCharges.forEach(tax => {
                totalTaxAmount = totalTaxAmount + parseFloat(tax.taxAmount.toFixed(2));
                totalTaxChargeBased = totalTaxChargeBased + tax.taxChargeBased;
            });
            totalTaxAmount = this._currencyPipe.getFormatedCurrency(totalTaxAmount, this.storeInfo);
            if (orderRequest.orderTax.toFixed(2) === totalTaxAmount.toFixed(2) && this.compareOrderTotal(totalTaxAmount, totalTaxChargeBased, orderRequest)) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    compareOrderTotal(totalTaxAmount: any, totalTaxChargeBased: any, orderRequest: Order): boolean {
        let countryCodes: any[] = ['ARE','QAT','OMN','KWT','SAU','BHR'];
        if (totalTaxChargeBased && totalTaxAmount && orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0
            && countryCodes.indexOf(orderRequest.countryCode) >= 0) {
            let taxTotal = totalTaxChargeBased + totalTaxAmount;
            let lineItemTotal = 0;
            orderRequest.orderLineItems.forEach(lineItems => {
                lineItemTotal = lineItemTotal + lineItems.unitTax + lineItems.totalAmount;
            });
            if ((Math.round((taxTotal + Number.EPSILON) * 100) / 100) == (Math.round((lineItemTotal + Number.EPSILON) * 100) / 100)) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
    /**
     * create order log request parameter
     */
    createOrderLog(res, message?: string) {
        const orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': res.id,
            'webOrderId': res.webOrderId,
            'message': message ? message : 'Order Placed by the agent',
            'source': Constants.CUSTOMER_SERIVCE
        };
        this._orderService.createOrderLog(orderLogRequest).subscribe((response) => {   },
         (error: any) =>
          {
           this._commonService.createNotification('', 'Failed to Create order log', NotificationType.ERROR);
        });
    }

    private orderSuccess(response: any) {
        this.paymentComponentSettings.webOrderId = response.webOrderId;
        this.paymentComponentSettings.orderReferenceId = response.id;
        this.orderFromLookup = false;
        this.fboid = '';
        this.clearAllTheForms(true);
        this.orderSubmitted = false;
        this.orderSession=null;
        this.openOrderViewTab(this.paymentComponentSettings.webOrderId);
        this.paymentComponentSettings = new PaymentComponentSettings();
    }

    processPaymentAfterOrderCreation(): void {

    }

    openOrderViewTab(weborderID: string, country?: string) {
        const orderInfo = new OrderInfoTab();
        orderInfo.webOrderID = weborderID;
        orderInfo.tabForOrderPromotion = true;
        orderInfo.homeCountry = this.selectedIsoCountryCode || country;
        orderInfo.newOrder = true;
        orderInfo.acceptDocuments = this.acceptPaymentDocuments;
        this.messageService.setOrderHistoryTab(orderInfo);
    }

    prepareOrderRequest(): any {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        let orderTypeId = PurchaseFlow.Personal_Order;
        // Updating the orderType ID based on the memberId
        const memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        if (this.memberTypeId === this.memberTypeEnum.GUEST || this.memberTypeId === this.memberTypeEnum.RETAIL) {
            orderTypeId = PurchaseFlow.Retail;
        }
        const orderRequest: any = {
            backDateOrder: this.posOrderFormGroup.value.backDateOrder,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: OrderStatus.Pending,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            email: this.memberInfo ? this.memberInfo.email  : null,
            languageCode: this.languageShortCode,
            languageCulture: this.storeDefaultLanguage,
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: memberTitleId,
            importFeeValue: this.importFeeValue,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null,
            orderSubTotal: this.calculateItemsSubTotal(this.storeInfo),
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: OrderSourceTypes.POS,
            orderGroupId: this.orderType.REGULAR,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: [],  //  For POS orders, Payment will be sent empty in order request
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            loggedInUserId: this.userInfo ? this.userInfo.userId : null,
            loggedInUserName: this.userInfo ? this.userInfo.userName : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: this.orderTaxResponse ? this.orderTaxResponse.erpTaxMetaData : null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.memberInfo && this.memberInfo.wholeSaleQualified ? this.memberInfo.wholeSaleQualified : false,
            memberTypeId: this.memberTypeId,
            sponsorId: this.memberInfo ? this.memberInfo.sponsorId : this.sponsorInformation
                ? this.sponsorInformation.sponsorId  : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
                : this.personalDiscountPercentage,
            memberLevelDiscount: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage) : 0,
            wholesaleQualifiedDiscount: this.memberInfo ?
                this._commonService.getWholesaleQualifiedDisc(this._orderService
                    .getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId)) : 0,
            optIn: this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId : null,
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            businessEntityId: this.businessEntityId,
            overrideMinimumLimit:this.isOverrideMinimumLimit,
            sourceTypeId: 5
        };
        console.log('DATA build');
        return orderRequest;
    }

    getCountryTaxInclusiveInfo(country: Country): boolean {
        let countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    }

    comparePriceTier(orderRequest: any, requestUrl: string): void {
        const memberDetails = this.memberInfo ? this.memberInfo  : null;
        if (orderRequest && orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0 && memberDetails) {
            const wholesaleQualified: boolean = memberDetails && memberDetails.wholeSaleQualified
                ? memberDetails.wholeSaleQualified : false;
            const optin: boolean = memberDetails && memberDetails.optin ? memberDetails.optin : false;
            let memberTitleId = memberDetails && memberDetails.memberLevelId
                ? this.memberInfo.memberLevelId : memberDetails && memberDetails.memberTitleId ? memberDetails.memberTitleId : null;
            const memberTypeId = memberDetails && memberDetails.memberTypeId ? memberDetails.memberTypeId : null;
            // HARD_DOWNGRADE CHECK FOR FPC USERS
            memberTitleId = this._orderService.getDowngradeTitleID(memberTypeId, memberTitleId);
            this._orderService.getPriceTierByMemberId(this.storeInfo.id, memberTitleId, wholesaleQualified, optin, this.storeInfo.taxInclusive).subscribe((response: PriceTierResponse) => {
                if (response && response.priceTireName) {
                    const priceTierName = response.priceTireName;
                    let isPriceTierMatched = true;
                    orderRequest.orderLineItems.forEach(item => {
                        if (priceTierName !== item.priceTierName) {
                            isPriceTierMatched = false;
                        }
                    });
                    this.checkLineItemsPriceTier(isPriceTierMatched, orderRequest, requestUrl);
                } else {
                    this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
                }
            }, (error) => {
                this.enablePaymentBlock(false);
                this.checkLineItemsPriceTier(false, orderRequest, requestUrl);
            });
        } else {
            this.checkLineItemsPriceTier(true, orderRequest, requestUrl);
        }
    }

    /**
     * @description check line items pricetier
     * @date 2019-10-16
     * @param {boolean} isPlaceOrder
     * @param {*} orderRequest
     * @returns {void}
     * @memberof OrderPromotionComponent
     */
    checkLineItemsPriceTier(isPlaceOrder: boolean, orderRequest: any, requestUrl: string): void {
        if (isPlaceOrder) {
            this.submitOrderBasedOnPriceTierCheck(orderRequest, requestUrl);
        } else {
            if (orderRequest.orderLineItems && orderRequest.orderLineItems.length > 0) {
                const productIds = orderRequest.orderLineItems.map((item: Product) => item.productId);
                if (productIds && productIds.length) {
                    this.posOrderFormGroup.get('items').reset();
                    const arr = <FormArray>this.posOrderFormGroup.controls.items;
                    arr.controls = [];
                    this.getProductsByIds(productIds, this.storeInfo);
                    const notification: any = this._translatePipe.get('order.Product prices are updated. please verify and submit order');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    this.isSubmitted = false;
                }
            }
            this.enablePaymentBlock(false);
        }
    }

    /**
     * @description submit Order
     * @date 2019-10-17
     * @param {*} orderRequest
     * @memberof OrderPromotionComponent
     */
    submitOrderBasedOnPriceTierCheck(orderRequest: any, requestUrl: string): void {
        if (orderRequest) {
            this.enablePaymentBlock(true);
            this._orderService.createNewOrder(orderRequest, requestUrl).subscribe((response: any) => {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        if (this.appConfig && this.appConfig.freeShippingFPCOrder) {
                            this.removeMemberDiscountOffer(this.memberInfo.memberId);
                        }
                        this.paymentComponentSettings.webOrderId = response.json().responseModel.webOrderId;
                        this.paymentComponentSettings.orderReferenceId = response.json().responseModel.id;
                        this.CreatePOSOrderInfo = response.json().responseModel;
                        this._cacheService.set(CacheKey.CREATE_POS_ORDER_INFO_SESSION_CODE, response.json().responseModel);
                        // this.createOrderLog(response.json().responseModel);
                        // this.orderSuccess(response.json().responseModel);
                        const subTotal=this.calculateItemsSubTotal(this.storeInfo);
                        this.isOverrideMinimumLimit && this.hasMinimumOverrideLimit && subTotal <=this.orderRules.minValue ? true:false;
                        this.onEnterPaymentDetailsClick();
                    } else if (response.json().responseModel.validations.some(x => x.code === ResponseStatus.TAX_ERROR)) {
                        this._commonService.createNotification('', 'Tax is not calculated. Please Click Enter Payment Details to proceed',
                            NotificationType.ERROR);
                        this.isPaymentBlockEnabled = false;
                    } else if (response.json().responseModel.validations.find(x => x.field === 'VAT REGITSTER')) {
                        const notification: any = this._translatePipe.get('order.VAT Registered Price Error');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    } else if (response.json().responseModel && response.json().responseModel.validations.length > 0) {
                        this._commonService.createNotification('', response.json().responseModel.validations[0].message,
                            NotificationType.ERROR);
                    }
                    this.isSubmitted = false;
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.The order cannot be created at this time. Please try again later.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isSubmitted = false;
                this.enablePaymentBlock(false);
            });
        }
    }

    /**
* @returns OrderLineItem
*/
    private getOrderLineItems(countryTaxInclusive: boolean): any[] {
        const lineItems: any[] = [];
        // const items: any = this.posOrderFormGroup.get('items');
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;
            let lineItemTax: any;
            this.products.sort((x, y) => {
              return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1 ;
             });
            this.products.forEach((product: any) => {
                if (product) {
                    let unitPrice: number = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    let retailPrice: number = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    let wholesalePrice: number = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (this.displayPriceConfig) {
                        unitPrice = this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (this.orderTaxResponse && this.orderTaxResponse.cart && this.orderTaxResponse.cart.orderLineItems
                        && this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax = this.orderTaxResponse.cart.orderLineItems.find(y => y.itemNumber === product.itemNumber);
                    }
                    const unitDiscountPrice = this.memberInfo && this.memberInfo.transactionalWholesaleQualified ?
                        (product.baseWholesalePrice - product.catalogPrice) : 0;
                    const lineItem: any = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (this.checkoutConfig && this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax ? lineItemTax.salesTax : 0,
                        unitTaxablePrice: lineItemTax && lineItemTax.taxablePrice ? lineItemTax.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        // totalAmount: this._currencyPipe.getFormatedCurrency(x.applicablePrice * x.quantity),
                        totalAmount: this._currencyPipe.getFormatedCurrency(this.getItemTotalSum(product), this.storeInfo),
                        discountAmount: this._currencyPipe.getFormatedCurrency
                            (this.calculateDiscountAmount(product, this.displayPriceConfig), this.storeInfo),
                        personalDiscount: this._currencyPipe.getFormatedCurrency(((
                            parseFloat(product.retailPrice.toFixed(2)) * product.quantity
                            * this.personalDiscountPercentage) / 100), this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: this.appConfig && this.appConfig.calculateNetUnitPrice
                            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
                            && this.memberInfo.transactionalOptin ? this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.display ? (product.display.comboBOMEnabled ? true : false) : false,
                        depositFeeProduct: product.display ? (product.display.depositFeeProduct? true: false) : false,
                        depositFeeEnabledProduct: product.productMetaData ? (product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1')? true: false) : false,
                        shippableFulfillment: product.shipping? (product.shipping.shippableFulfillment? true : false) : false
                    };
                    lineItems.push(lineItem);
                }

            });
        }
        return lineItems;
    }

    /**
     * @description get FBO eligible product
     * @date 2019-07-04
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    private getFBOEigibleProduct(product: Product): boolean {
        if (product.productMetaData) {
            const fboEligibilty = product.productMetaData.
                find(x => x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE);
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
                return true;
            }
        }
    }

    private getOrderShippings(): any[] {
        const orderShippings: any[] = [];
        const selectedPOSLocation = this.posLocations.find(location =>
            location.id === +this.posOrderFormGroup.controls['posLocation'].value);
        const orderShipping: any = {
            deliveryPreferenceId: DeliveryPreference.PICKUP,
            shipMethodId: this.posOrderFormGroup.value.posLocation,
            shortCode: this.shipMethod.shortCode,
            distributionCenter: selectedPOSLocation ? selectedPOSLocation.name : ''
        };
        orderShippings.push(orderShipping);
        return orderShippings;
    }
    /**
      * @returns payment method
      */
    private getPaymentMethodById(paymentMethodId: number): any {
        let paymentType: string;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.Direct_Debit:
                paymentType = PaymentMethodTypes.Direct_Debit;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

        }
        return paymentType;
    }

    getAddresses(): any {
        const addresses: any[] = [];
        const pickupAddress = this.getPickUpAddress();
        if (pickupAddress) {
            pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction :  '' ;
            pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
            addresses.push(pickupAddress);
        }
        if (this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) {
            addresses.push(this.getBillingAddress());
        }
        return addresses;
    }

    calculateOrderTotal(): number {
        let totalCost = 0;
        let calculateVatTax=true;
        if (this.memberInfo && this.memberInfo.vatRegistered
            && this.countryTaxInclusive) {
                if( ( this.appConfig && this.appConfig.enableVatItemizationForNonVat ) || this.appConfig.displayTaxInclusivePrice){
                    if(this.appConfig && this.appConfig.calculateVatForVatRegisterUser){
                        calculateVatTax =true;
                    }else{
                    calculateVatTax =false;
                    }
                }
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) + (this.handlingCharges) + (calculateVatTax ? this.taxableAmount|| 0 :0);
        } else {
          if(this.appConfig && this.appConfig.enableVatItemizationForNonVat ){
            if(this.memberInfo && this.memberInfo.memberTypeId=== this.memberTypeEnum.DISTRIBUTOR)
            {
              calculateVatTax =true;
            }
            else{
              calculateVatTax =false;
            }
          }
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            totalCost = this.calculateItemsSubTotal(this.storeInfo) + (this.importFeeValue) + (this.handlingCharges)
               + ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (calculateVatTax ? this.taxableAmount || 0:0) : 0);}
        if (this.storeInfo) {
            totalCost = Number(totalCost.toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.orderTotal = totalCost;
        return totalCost;
    }

    /**
   * @param  {any} shippingInfo
   * @returns void
   */
    calculateOrderTax(): void {
        this.taxCalculationStatus = true;
        this.orderTaxResponse = null;
        if (this.storeInfo && this.products && this.products.length > 0 &&  this.shippingMethodId) {
            const taxRequest: TaxRequest = this.prepareTaxRequest();
            if (taxRequest && taxRequest.fromAddress && taxRequest.toAddress) {
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe((taxResponse: any) => {
                        this.disableQty = false;
                        if (taxResponse && taxResponse.success) {
                            this.isTaxMetaDataAvailable = taxResponse.taxMetaData ?  true : false;
                            if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                                taxResponse.cart.totalTax = this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, this.storeInfo);
                                this.orderTaxResponse = taxResponse;
                                this.taxableAmount = taxResponse.cart.totalTax;
                                if (this.orderTaxResponse && this.orderTaxResponse.taxMetaData
                                    && this.orderTaxResponse.taxMetaData.orderTaxCharges
                                    && this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                                    const gst = this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
                                    const pst = this.orderTaxResponse.taxMetaData
                                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
                                    this.gstTax = gst ? gst.taxAmount : 0;
                                    this.pstTax = pst ? pst.taxAmount : 0;
                                    // if (this.countryTaxInclusive) {
                                    //     const shippingLineItem = this.orderTaxResponse.taxMetaData
                                    //         .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.NOR && tax.lineNo === 0);
                                    //     if (shippingLineItem) {
                                    //         this.shippingTax = shippingLineItem.taxAmount;
                                    //     }
                                    // }
                                }
                            }
                            setTimeout(() => {
                                this.taxCalculationStatus = false;
                            }, 500);
                        }
                    },
                        (error: any) => {
                            if (error) {
                                const taxResponse = error;
                                if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                                    if((taxResponse.validations.map(validation => validation.name).indexOf(CommonConstant.Order_Tax))>-1) {
                                        const notification: any = this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                    else {
                                        const notification: any = this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                }
                                this.disableQty = false;
                            }
                        });
            }

        }
        console.log("calculateOrderTax taxCalculationStatus", decodeURIComponent(encodeURIComponent(String(this.taxCalculationStatus))));
    }

    private prepareTaxRequest(): TaxRequest {
        const memberTitleId = this.memberInfo ? this._orderService.getMemberTitleId(this.memberInfo) : MemberLevel.RETAIL;
        const posLocation = this.posLocations.find(x=> x.id === this.shippingMethodId);
        const taxRequest: TaxRequest = {
            orderID: 0,
            memberID: this.memberInfo ? this.memberInfo.memberId : null,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: this.getPickUpAddress(),
            toAddress:  this.getPickUpAddress(),
            memberNumber: this.memberInfo ? this.memberInfo.fboId : null,
            orderNumber: 0,
            storeID:  posLocation ? posLocation.storeId : null,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: ShippingType.PICKUP,
            orderSource: 'POS',
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: memberTitleId,
            wholesaleQualified: this.memberInfo ? this.memberInfo.wholeSaleQualified : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            isDiscountedShipping: this.posOrderFormGroup.value.isShippingDiscountApplied,
            memberType: MemberTypeEnum[this.memberTypeId]
        };
        return taxRequest;
    }
    /**
      * @returns TaxCart
      */
    private mapCartToTaxCart(): any {
        const taxCart: any = {
            shippingTax: 0,
            shipMethodId: this.shippingMethodId,
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    }

    /**
     * @returns CartItems
     */
    private mapItemstoTaxItems(): any[] {
        const address = this.getPickUpAddress();
        const taxItems: any[] = [];
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;
            if (address && address.countryId && this.countries && this.countries.length > 0) {
                const country = this.countries.find(x => x.countryId === address.countryId);
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }
            this.products.forEach((x: any) => {
                let taxablePrice: any;
                let paidPrice: any;
                if (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) {
                    taxablePrice = x.catalogPrice;
                    paidPrice = x.applicablePrice;
                } else {
                    taxablePrice = ((this.checkoutConfig.catalogPriceAsTaxablePrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.catalogPrice : x.retailPrice);
                    paidPrice = ((this.checkoutConfig.applicablePriceAspaidPrice ||
                        (address && address.stateCode && address.stateCode === 'PR')) ? x.applicablePrice : x.retailPrice);
                }
                const taxItem: any = {
                    lineNumber: ++itemLineNumber,
                    itemNumber: x.itemNumber,
                    taxablePrice: this.getTaxablePrice(taxablePrice,x),
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',//x.shortDescription,
                    taxInclusive: this.countryTaxInclusive ? true : false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: this.getPaidPrice(paidPrice,x),
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit,
                    unitTaxExclusiveRetailPrice: x.baseRetailPrice,
                    computedTaxInclusivePrice: x.computedTaxInclusivePrice,
                    comboBOMEnabled: x.display ? (x.display.comboBOMEnabled ? x.display.comboBOMEnabled : false) : false,
                    computedComboTaxTotals: x.computedComboTaxTotals && x.computedComboTaxTotals.length > 0 ? x.computedComboTaxTotals : []
                };
                taxItems.push(taxItem);
            });
        }
        return taxItems;
    }
    getTaxablePrice(taxablePrice: number, item: any): number {
        const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin && !this.memberInfo.vatRegistered &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                && enableWHLSAL00ForAsstSupervisor)) {
            return this.calculateNetUnitPrice(item);
        } else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        } else if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        } else{
            return taxablePrice;
        }

    }

    getPaidPrice(paidPrice: number, item: any): number {
        if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === PriceTier.NEWDST || item.priceTierName === PriceTier.WHLSAL)) {
            return item.applicablePrice;
        } else {
            return paidPrice;
        }
    }

    getPriceTier() {
        let priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    }

    addNewProductItem(items, index, product) {
        const itemValue = product.itemNumber + ' - ' + product.name;
       items.controls[index].controls['itemNumber'].setValue(itemValue);
       const itemImage = (product.imageModelList && product.imageModelList.length > 0)
           ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
       const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
           : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
        const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
       items.controls[index].controls['productImage'].setValue(imageUrl);
       items.controls[index].controls['productNumber'].setValue(product.itemNumber);
       items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
       items.controls[index].controls['productId'].setValue(product.id);
       items.controls[index].controls['productItem'].setValue(product);
       items.controls[index].controls['disableIncrement'].setValue(false);
       items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
       items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
       return items;
    }

    checkStockAvalible(product):any {
        let productids:number[]=[];
        productids.push(product.id);
        this._customerService.getProductsByLocation(this.currentPosLocation.id,productids)
        .subscribe(response => {
           this.productwareHouseLocation =response;
           if(this.productwareHouseLocation  && this.productwareHouseLocation.length>0){


            return true;
           }
           if(this.productwareHouseLocation && this.productwareHouseLocation.length==0){
            return true;
           }

        });


   }

    setFocusbyID(id) {
        setTimeout(() => {
            const element = document.getElementById(id) as HTMLInputElement;
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    }
    moveToItemLevelSearchBlock(event: any) {
        if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
            this.itemLevelSearch.nativeElement.focus();
        }
    }

    /**
     * @description item number search in table
     * @date 2019-09-25
     * @param {*} event
     * @memberof OrderPromotionComponent
     */
    itemLevelSearchEvent(event: any) {
        if(event.currentTarget.value && this.posOrderFormGroup && this.posOrderFormGroup.value && this.posOrderFormGroup.value.items.length>0){
            let items: any = this.posOrderFormGroup.get('items');
            const product:any=this.posOrderFormGroup.value.items.find(i=>i.productNumber === event.currentTarget.value);
            const sameProductIndex = items.controls.findIndex(item =>
                item.controls['productNumber'].value === event.currentTarget.value);
                if(sameProductIndex >= 0 && product){
                    this.incrementQuantity(sameProductIndex);
                    this.posOrderFormGroup.controls['itemLevelSearch'].setValue('');
                }else{

                this.itemLevelSearchEventUpdate(event);
                }

        }else{
            this.itemLevelSearchEventUpdate(event);

        }
    }
    itemLevelSearchEventUpdate(event:any){
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe((products) => {
                const responseproducts = products;
                if (responseproducts.length > 0) {
                    const product = responseproducts[0];
                    if(product && product.id){
                        this._customerService.getProductsByLocation(this.currentPosLocation.id, [product.id])
                            .subscribe(response => {
                                this.productwareHouseLocation = response;
                                let items: any = this.posOrderFormGroup.get('items');
                                if (this.productwareHouseLocation && this.productwareHouseLocation.length > 0) {
                                    if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity > 0) {
                                        if (items && items.length >= 0) {
                                            const sameProductIndex = items.controls.findIndex(item =>
                                                item.controls['productNumber'].value === product.itemNumber);
                                            if (sameProductIndex >= 0) {
                                                if (+items.controls[sameProductIndex].controls['quantity'].value + 1 <= this.productwareHouseLocation[0].stockQuantity) {
                                                    items.controls[sameProductIndex].controls['quantity']
                                                        .setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                                    this.setFocusbyID('quantity-' + (sameProductIndex));
                                                }else {
                                                    let addedNotification: any = 'can not add product ' +items.value[sameProductIndex].productName+' Avalible Quantity '+this.productwareHouseLocation[0].stockQuantity;
                                                    this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                                                    if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                                                        this.itemLevelSearch.nativeElement.focus();
                                                    }
                                                    this.taxCalculationStatus = false;
                                                }
                                            } else {
                                                this.addItemNumber();
                                                const index = (items.length - 1);
                                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                                if (!items.controls[index].controls['quantity'].value) {
                                                    items.controls[index].controls['quantity'].setValue(1);
                                                }
                                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                                items = this.addNewProductItem(items, index, product);
                                                this.setFocusbyID('quantity-' + (items.length - 1));
                                            }
                                        }
                                        this.updateTotalsAndShipMethod();
                                        this.getHandlingFeeCharges();
                                    }
                                    if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity <= 0) {
                                        let addedNotification: any = 'Out of stock -' + product.displayName;
                                        if (this.taxCalculationStatus) {
                                            this.taxCalculationStatus = false;
                                        }
                                        this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                                        this.posOrderFormGroup.controls['itemSearch'].setValue('');
                                    }
                                    if (!this.productwareHouseLocation[0].manageStock) {
                                        this.addItemNumber();
                                        const index = (items.length - 1);
                                        items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                        if (!items.controls[index].controls['quantity'].value) {
                                            items.controls[index].controls['quantity'].setValue(1);
                                        }
                                        items.controls[index].controls['quantity'].updateValueAndValidity();
                                        items = this.addNewProductItem(items, index, product);
                                        this.setFocusbyID('quantity-' + (items.length - 1));
                                        this.updateTotalsAndShipMethod();
                                        this.getHandlingFeeCharges();
                                    }
                                }
                                if (this.productwareHouseLocation && this.productwareHouseLocation.length == 0) {
                                    this.addItemNumber();
                                    const index = (items.length - 1);
                                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                    if (!items.controls[index].controls['quantity'].value) {
                                        items.controls[index].controls['quantity'].setValue(1);
                                    }
                                    items.controls[index].controls['quantity'].updateValueAndValidity();
                                    items = this.addNewProductItem(items, index, product);
                                    this.setFocusbyID('quantity-' + (items.length - 1));
                                    this.updateTotalsAndShipMethod();
                                    this.getHandlingFeeCharges();
                                }
                                const isDepositFeeProductEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                                if (isDepositFeeProductEnabled && this.productwareHouseLocation && this.productwareHouseLocation.length > 0 && 
                                    ((this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity > 0) || !this.productwareHouseLocation[0].manageStock)) {
                                    this.getDepositFeeProduct(product);
                                    this.updateTotalsAndShipMethod();
                                    this.getHandlingFeeCharges(); 
                                }
                            },
                            (error)=>{
                                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                            }
                        );
                    }
                } else {
                    let items: any = this.posOrderFormGroup.get('items');
                    if (items && items.length > 0) {
                        if (this.taxCalculationStatus) {
                            this.taxCalculationStatus = false;
                        }
                    }
                    if (this.itemLevelSearch && this.itemLevelSearch.nativeElement) {
                        this.itemLevelSearch.nativeElement.focus();
                    }
                    const notification: any = this._translatePipe.get('order.Invalid Item Number');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
                this.posOrderFormGroup.controls['itemLevelSearch'].setValue('');
            });
        }
        console.log("itemLevelSearchEventUpdate taxCalculationStatus",this.taxCalculationStatus);
    }

    /**
     * @description Check stock available or not
     * @date 2019-09-25
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    stockAvailable(product: Product): boolean {
        //return (product.manageStock && product.stockQuantity > 0) || (product.stockAvailable && !product.manageStock);
        return (product.manageStock && product.stockQuantity > 0) || !product.manageStock;
    }

    getDepositFeeProduct(product?: Product) {
        this.disableQty = true;
        let depositFeeProduct: Product = null;
        this.searchProduct = product? product : this.searchProduct;
        const productAssociation = this.productAssociationInfo.find(x => x.productId === this.searchProduct.id);
        if (productAssociation) {
            depositFeeProduct = this.depsoitFeeProductsInfo.find(x => x.id === productAssociation.depositFeeProductId);;
            if(depositFeeProduct){
                depositFeeProduct.productQuantity = 1;
                this.searchProduct = depositFeeProduct;
                this.onItemSelect(true);
            }
        } else {
            const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
            const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
            this._customerService.getRelatedProducts(this.storeId, this.searchProduct.id, 2, this.memberInfo.memberTitleId, this.countryCode, this.storeDefaultLanguage,this.purchaseFlowType, this.storeInfo.taxInclusive, wholesaleQualified, optin)
                .subscribe(response => {
                    if (response && response.length) {
                        depositFeeProduct = response[0];
                        const depositFeeProductInfo = this.depsoitFeeProductsInfo.find(x => x.id === depositFeeProduct.id);
                        this.productAssociationInfo.push({
                            productId: this.searchProduct.id,
                            depositFeeProductId: depositFeeProduct.id
                        });
                        if (!depositFeeProductInfo) {
                            this.depsoitFeeProductsInfo.push(depositFeeProduct);
                        }
                        this.searchProduct = depositFeeProduct;
                        this.onItemSelect(true);
                    }
                });
        }
    }
    /**
     * @description auto complete search
     * @date 2019-09-25
     * @memberof OrderPromotionComponent
     */
    onItemSelect(isDepositFeeProductEnabled?: boolean) {
        if(!isDepositFeeProductEnabled){
            this.searchProduct = this.posOrderFormGroup.controls['itemSearch'].value;
        }
        let items: any = this.posOrderFormGroup.get('items');
        const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value === this.searchProduct.itemNumber);
        if (this.searchProduct && this.searchProduct.id) {
            console.log("onItemSelect taxCalculationStatus", this.taxCalculationStatus);
            this.disablePaymentDetailButton();
            let productids: number[] = [];
            productids.push(this.searchProduct.id);
            this.posOrderFormGroup.controls['itemSearch'].setValue('');
            this._customerService.getProductsByLocation(this.currentPosLocation.id, productids)
                .subscribe(response => {
                    this.productwareHouseLocation = response;
                    if (this.productwareHouseLocation && this.productwareHouseLocation.length > 0) {
                        if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity > 0) {
                            if (sameProductIndex >= 0) {
                                if (+items.controls[sameProductIndex].controls['quantity'].value + 1 <= this.productwareHouseLocation[0].stockQuantity) {
                                    this.addProductItemtoCart();
                                } else {
                                    let addedNotification: any = 'can not add product ' + items.value[sameProductIndex].productName + ' Avalible Quantity ' + this.productwareHouseLocation[0].stockQuantity;
                                    if (this.taxCalculationStatus) {
                                        this.taxCalculationStatus = false;
                                    }
                                    this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                                    this.posOrderFormGroup.controls['itemSearch'].setValue('');
                                }
                            } else {
                                this.addProductItemtoCart();
                            }
                        }
                        if (this.productwareHouseLocation[0].manageStock && this.productwareHouseLocation[0].stockQuantity <= 0) {
                            let addedNotification: any = 'Out of stock -' + this.searchProduct.displayName;
                            if (this.taxCalculationStatus) {
                                this.taxCalculationStatus = false;
                            }
                            this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
                            this.posOrderFormGroup.controls['itemSearch'].setValue('');
                        }
                        if (!this.productwareHouseLocation[0].manageStock) {
                            this.addProductItemtoCart();
                        }
                    }
                    if (this.productwareHouseLocation && this.productwareHouseLocation.length == 0) {
                        this.addProductItemtoCart();
                    }
                });
                console.log("onItemSelect taxCalculationStatus 2", this.taxCalculationStatus);
        }
        // else {
        //         this._commonService.createNotification('', 'Out of stock - '
        //             + (this.posOrderFormGroup.controls['itemSearch'].value.name || ''), NotificationType.ERROR);
        //         this.posOrderFormGroup.controls['itemSearch'].setValue('');
        //         setTimeout(() => {
        //             if (this.seachItemElement && this.seachItemElement.nativeElement) {
        //                 this.seachItemElement.nativeElement.focus();
        //             }
        //         }, 500);
        //     }
    }
    addProductItemtoCart(){
        this.posOrderFormGroup.controls['itemSearch'].setValue('');
        let items: any = this.posOrderFormGroup.get('items');
        if (items && items.length >= 0) {
            this.taxCalculationStatus = true;
            const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value === this.searchProduct.itemNumber);
            if (sameProductIndex >= 0) {
                items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                this.posOrderFormGroup.controls['itemSearch'].setValue('');
                this.setFocusbyID('quantity-' + (sameProductIndex));
            } else {
                this.addItemNumber();
                const index = (items.length - 1);
                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                if (!items.controls[index].controls['quantity'].value) {
                    items.controls[index].controls['quantity'].setValue(1);
                }
                items.controls[index].controls['quantity'].updateValueAndValidity();
                if (this.searchProduct) {
                    const typHeadItem = this.searchProduct;
                    this.posOrderFormGroup.controls['itemSearch'].setValue('');
                    items = this.addNewProductItem(items, index, typHeadItem);
                }
                this.updateTotalsAndShipMethod();
                this.isFocused = true;
                this.setFocusbyID('quantity-' + (items.length - 1));
            }
            const isDepositFeeProductEnabled = this.searchProduct.productMetaData.find(x=>x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED);
            if(isDepositFeeProductEnabled) {
                this.getDepositFeeProduct();
            }
            this.updateTotalsAndShipMethod();
            this.getHandlingFeeCharges();
        }
        console.log("addProductItemtoCart taxCalculationStatus",this.taxCalculationStatus);

    }
    allowOnlyNumbers(event: any) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            const value: any = (event.key ? event.key : '');
            const pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }

    /**
     * @description save billing address
     * @date 2018-11-19
     * @param {Address} address
     * @memberof OrderPromotionComponent
     */
    saveBillingAddress(address: Address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    }

    // *************************payvision payment section*******************************/
    /**
     * @description Load Member Saved Cards
     * @date 2018-08-30
     * @memberof PaymentComponent
     */
    loadSavedCardsForMemberId(memberId: number, countryCode: string): void {
        const paymentInstrumentId: number = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode,
            paymentInstrumentId).subscribe((savedCardResponse: PayvisionSavedCardResponse) => {
                if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                    this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                    this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                        card.notes = card.defaultCard ? PaymentConstants.default : '';
                    });
                    //  if (this.orderSession) {
                    if (paymentInstrumentId) {
                        const selectedCard = this.paymentComponentSettings.savedCards.find(x => x.id === paymentInstrumentId);
                        if (selectedCard) {
                            const indexPostion = this.paymentComponentSettings.savedCards.findIndex(x => x.id === paymentInstrumentId);
                            this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                            this.paymentComponentSettings.savedCards.unshift(selectedCard);
                            this.selectedpayvisionCardInfo = selectedCard;
                        }
                        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                        this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                        this._cacheService.remove(CacheKey.PaymentInstrumentId);
                    } else {
                        if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                            const defaultCard = this.paymentComponentSettings.savedCards.find(card => card.expired === false && card.defaultCard === true);
                            if(defaultCard){
                                this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(defaultCard.id);
                                this.selectSavedCard(defaultCard);
                            }
                            else{
                                let isDefaultCard = false;
                                this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                                    if (card.expired === false && isDefaultCard === false) {
                                        isDefaultCard = true;
                                        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                        this.selectSavedCard(card);
                                    }
                                });
                            }    
                        } else {
                            this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
                            // this.posOrderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                            this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                        }
                    }
                } else {
                    this.paymentComponentSettings.savedCards = [];
                }
            }, (error: Response) => {
                this.paymentComponentSettings.isAddNewCard = false;            
            });
    }
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    getImagePath(cardType: any): string {
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    this.paymentComponentSettings.cardTypeImage = null;
                    break;
            }
        }
        return this.paymentComponentSettings.cardTypeImage;
    }

        /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
      private mapVerifiedAddressToFormFields(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, address.state);
            const mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3 ? address.addressLine3 : '',
                addressLine4: address.addressLine4 ? address.addressLine4 : '',
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj.id,
                stateCode: stateObj.stateCode,
                countryCode: countryObj.countryCode || countryObj.isocodeThree,
                countryId: countryObj.countryId,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, '') : null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                latitude: address.latitude,
                longitude: address.longitude,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.posOrderFormGroup.value.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mapAddressToFields;
        }
    }

    /**
     * On change of card
     */
    selectSavedCard(cardDetails: any, isNewCard?: boolean,amount?:number) {
        this._cacheService.set(CacheKey.IsRefreshed, true);
        this.addNewCardClicked = false;
        this.paymentComponentSettings.amount=amount;
        this.mapBillingAddress();
        this.isNewCardClicked = isNewCard;
        if (isNewCard) {
            this.selectedpayvisionCardInfo = null;
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            } else if (this.isAdyenPayment) {
                this.paymentComponentSettings.amount = this.orderTotal ? this.orderTotal : this.calculateOrderTotal();
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            } else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            } else if (this.isNexioPayment && this.enableNexioPaymentForPickUpCenter) {
                this.showNexioPayment = true;
                this.showNexioPopup.open();
            } 
            else {
                this.addNewpayvisionCard = true;
                this.payvisionPayment.open();
            }
        } else {
            this.selectedpayvisionCardInfo = cardDetails;
            this.addNewpayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.showAdyenPayment = false;
            this.showNexioPayment = false;
        }
    }

    addOrderInfoToSession() {
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        const formValues = this.posOrderFormGroup.value;
        const OrderInfo = {
            products: this.products,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shipMethodId: formValues.shipMethodId,
            orderFromLookup: this.orderFromLookup,
            saveForFutureUse: this.posOrderFormGroup.value.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            language: this.posOrderFormGroup.value.language,
            minMaxPriceValidation: this.minMaxPriceValidation,
            posLocation: this.posOrderFormGroup.value.posLocation,
            splitPayments: this.splitPayments,
            paymentComponentSettings: this.paymentComponentSettings,
            orderTotal: this.orderTotal,
            businessEntityId: this.businessEntityId,
            isOverrideMinimumLimit:this.isOverrideMinimumLimit
        };
        sessionStorage.setItem(CacheKey.OrderInfo, JSON.stringify(OrderInfo));
    }
    /**
     *load procducts from session
     */
    loadproductsFromSession() {
        this.orderSession.products.forEach((product: any) => {
            this.addItemNumber();
            const items: any = this.posOrderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    const isDepositFeeProduct = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1');
                    const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    items.controls[index].controls['quantity'].setValue(product.quantity);
                    items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                    items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                }
            }
        });
        this.updateTotalsAndShipMethod();
        this.getHandlingFeeCharges();
    }

    /**
     * on close of payvision form popup
     */
    onPayvisionFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
                sessionStorage.removeItem(CacheKey.OrderInfo);
                sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewpayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
         // To remove payvision Configurations
         this._commonService.unloadPayvisionWidget();
    }

    /**
    * @returns any
    */
    private getOrderPaymentInfo(): any[] {
        const payments: any[] = [];
        if (this.paymentComponentSettings.webOrderId) {
            let paymentMethodType: string;
            paymentMethodType = this.getPaymentMethodById(+this.posOrderFormGroup.controls['paymentSelector'].value);
            const orderPayment: any = {
                savePaymentMethod: this.savePaymentMethod && this.posOrderFormGroup.value.orderType !== this.orderType.NEW_GUEST_RETAIL
                    ? this.savePaymentMethod : false,
                paymentAmount: this.calculateOrderTotal(),
                redirect: false,
                orderSourceTypeId: OrderSourceValue.CUSTOMER,
                memberPaymentMethodId: +this.posOrderFormGroup.controls['paymentSelector'].value,
                //  === this.selectEnum.firstOption.toString() ? this.getPaymentMethodId('Credit_Card') : this.getPaymentMethodId('eCheck'),
                creditCardModel: {
                    currencyCode: this.storeInfo.currencyCode,
                    paymentToken: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.token : null,
                    paymentMethodType: paymentMethodType,
                    maskedCreditCardNumber: this.posOrderFormGroup.controls['paymentSelector'].value
                        === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.maskedCard : null,
                    cardHolderName: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.nameOnTheCard : null,
                    expMonth: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.expiryMonth : null,
                    expYear: this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()
                        ? this.selectedpayvisionCardInfo.expiryYear : null
                },
                paymentECheck: (this.posOrderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()
                ) ? this.getEcheckInfo() : null
            };
            payments.push(orderPayment);
        }
        return payments;
    }

    /**
         * get controls of items
         */
    getItemsControl() {
        return <FormArray>this.posOrderFormGroup.get('items');
    }

    /**
     * On paste event for member Info
     */
    onPasteEvent() {
        setTimeout(() => {
            this.posOrderFormGroup.controls['memberInfo'].setValue(this.posOrderFormGroup.controls['memberInfo'].value.trim());
        }, 0);
    }
    // *************************************** ECheck Payment****************************/
    /**
     * Get ECheck payment
     */
    getSavedEchecks(): void {
        if (this.memberInfo.memberId) {
            this._echeckService.getSavedEchecks(this.memberInfo.memberId, this.selectedIsoCountryCode, this.eCheckTokenRes)
                .subscribe((response: PersonalCheck[]) => {
                    if (response && response.length > 0) {
                        this.paymentComponentSettings.savedEChecks = response;
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            const selectedCard = this.paymentComponentSettings.savedEChecks.find(x => x.id === this.echeckRequest.id);
                            if (selectedCard) {
                                const indexPostion = this.paymentComponentSettings.savedEChecks
                                    .findIndex(x => x.id === this.echeckRequest.id);
                                this.paymentComponentSettings.savedEChecks.splice(indexPostion, 1);
                                this.paymentComponentSettings.savedEChecks.unshift(selectedCard);
                                this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                            } else {
                                const index = this.paymentComponentSettings.savedEChecks.length - 1;
                                this.posOrderFormGroup.controls['paymentInstrumentId']
                                    .setValue(this.paymentComponentSettings.savedEChecks[index].id);
                            }
                            // this.selectECheck();
                        }

                    } else {
                        this.paymentComponentSettings.savedEChecks = [];
                        this.savedEChecks = '';
                    }
                    this.savedEChecks = JSON.stringify(this.paymentComponentSettings.savedEChecks);
                });
        }
    }

    /**
     * On payment group radio button change
     */

    onPaymentMethodGroupChange(groupId:number){
        if(groupId===this.posPaymentGroupEnum.External_Payment){
            this.isPayByLinkValid = true;
            this.agreementCheckError = false;
            this.clearPaymentMethodTypeFormForm();
            this.buildExternalPaymentForm();
            this.balanceOrderTotal = this.orderTotal;
        } else if (groupId === this.posPaymentGroupEnum.Integrated_Payments) {
            this.isTerminalSelected = false;
            this.createPaymentMethodTypeForm();
            this.balanceOrderTotal = 0;
        }else if(groupId===this.posPaymentGroupEnum.Split_Payment){
            this.isPayByLinkValid = true;
            this.agreementCheckError = false;
            this.clearPaymentMethodTypeFormForm();
            this.buildSplitPaymentForm();
            this.balanceOrderTotal = 0;
        }
    }


    /**
     * on change of payment method
     */
    onPaymentMethodChnage() {
        this.createOrder();
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.selectedpayvisionCardInfo = null;
        this.echeckRequest = null;
        const options: any[] = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer,
        this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Pay_By_Link];
        if (options.some(x => x == (+this.posOrderFormGroup.controls['paymentSelector'].value))) {
            this.posOrderFormGroup.controls['paymentInstrumentId'].setValidators([]);
        } else {
            // this.posOrderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
        }
        this.posOrderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
    }

     /**
     * @description to get payment terms and Conditions documents
     * @param storeInfo
     */
      getPaymentTermsAndPoliciesDocuments() {
        const accountlevelID = this._commonService.getMemberAccountLevelId(this.memberInfo);
        if (accountlevelID) {
            this._documentService.getDocuments(Portal.Csp, accountlevelID, DisplaySectionId.Payment_Page, this.countryCode, this.storeDefaultLanguage).subscribe(
                (res) => {
                    if (res && res[0] && res[0].body && res[0].body.length > 0) {
                        this.paymentTermsAndPoliciyDocuments = res[0].body;
                        this.paymentTermsAndPoliciyDocuments.forEach(item => {
                            item.isSelected = true
                        });
                    }
                },
                (error) => {
                }
            );
        }
    }

    checkPaymentTermsAndPolicies(index:number){
        this.paymentTermsAndPoliciyDocuments[index].isSelected = !this.paymentTermsAndPoliciyDocuments[index].isSelected;
        this.checkPaymentDocumentsSelected();
    }

    checkPaymentDocumentsSelected(): void {
        if (this.paymentTermsAndPoliciyDocuments && !this.paymentTermsAndPoliciyDocuments.every(x => x.isSelected)) {
            this.agreementCheckError = true;
        } else {
            this.agreementCheckError = false;
        }
    }

    getAcceptPaymentDocuments() {
        if (+this.paymentMethodTypeForm.controls['paymentMethodType'].value==this.paymentTypeEnum.Direct_Debit) {
            this.acceptPaymentDocuments = {
                memberId: this.memberInfo.memberId,
                memberTypeId: this.memberInfo.memberTypeId,
                documents: this.paymentTermsAndPoliciyDocuments
            };
        } else {
            this.acceptPaymentDocuments = null
        }
    }

    /**
     *  getting pos payment methods after clicking
     * Enter payment details button
     */
    onEnterPaymentDetailsClick(){
        this.enablePaymentBlock(true);
        this.balanceOrderTotal = this.orderTotal;

        this._orderService.getPosPaymentMethods(this.storeId,
            this.currentPosLocation.id, PurchaseFlow.Personal_Order).subscribe(
            (response)=>{
                this.terminalDownConfig = MULTI_SELECT_CONFIG_INTEGRATED_TERMINAL;
                if(response && response.posPaymentMethodModels){
                    this.posPaymentMethods = response.posPaymentMethodModels;
                    if(this.posPaymentMethods && this.posPaymentMethods.length >0){
                    this.posPaymentGroups = [];
                    this.terminalOptions = []
                    this.posPaymentMethods.forEach((payment) => {
                        if (payment.rowStateID === RowStatus.Active && payment.storePOSTerminalId) {  
                            let terminalModel = Object.assign({}, payment.terminalModel)
                            this.terminalOptions.push(terminalModel);
                        }
                        if (this.posPaymentGroups.length === 0) {
                            this.posPaymentGroups.push({
                                id: payment.paymentMethodsModel.paymentGroupID,
                                name: payment.paymentMethodsModel.groupName
                            });
                        } else {
                            const group = this.posPaymentGroups.find((paymentGroup) =>
                                paymentGroup.id === payment.paymentMethodsModel.paymentGroupID);
                            if (!group) {
                                this.posPaymentGroups.push({
                                    id: payment.paymentMethodsModel.paymentGroupID,
                                    name: payment.paymentMethodsModel.groupName
                                });
                            }
                        }
                    });
                        if (this.posPaymentMethods && this.posPaymentMethods.length > 0) {                 
                            this.integratedPaymentMethods = this.posPaymentMethods.filter(x => x.paymentMethodsModel.paymentGroupID === this.posPaymentGroupEnum.Integrated_Payments && x.paymentMethodsModel.paymentMethodId > 0 && x.paymentMethodsModel.paymentMethodId != PaymentType.INTEGRATED_TERMINAL);
                            let integratedTerminalPaymentMethod = this.posPaymentMethods.find(x => x.paymentMethodsModel.paymentMethodId === PaymentType.INTEGRATED_TERMINAL)
                            if(integratedTerminalPaymentMethod && this.terminalOptions && this.terminalOptions.length > 0){
                                this.prepareIntegratedPaymentMethods(integratedTerminalPaymentMethod);                                
                            }
                        }
                        const directDebitIndex = this.integratedPaymentMethods.findIndex((x) => x.paymentMethodsModel
                            && x.paymentMethodsModel.paymentMethodId == PaymentType.Direct_Debit);
                        if (directDebitIndex > -1 && this.memberInfo && this.memberInfo.memberId
                            && this.memberInfo.memberTypeId == MemberTypeEnum.DISTRIBUTOR) {
                            this.filterDirectDebitPayment(directDebitIndex);
                        } else {
                            if(directDebitIndex > -1){
                                this.integratedPaymentMethods.splice(directDebitIndex, 1);
                            }
                    this.buildPaymentForm();
                }
                    } else {
                    this.enablePaymentBlock(false);
                    const errorMessage: any = 'POS Payment methods are not configured, Please select Different Location.';
                    this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
                }
             }
            },
            (error)=>{
                this.enablePaymentBlock(false);
                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            }
        );
    }

    prepareIntegratedPaymentMethods(integratedTerminalPaymentMethod) {
        this.integratedPaymentMethods.push({
            terminals: this.terminalOptions,
            locationId: integratedTerminalPaymentMethod.locationId ? integratedTerminalPaymentMethod.locationId : null,
            orderTypeId: integratedTerminalPaymentMethod.orderTypeId? integratedTerminalPaymentMethod.orderTypeId : null,
            paymentMethodsModel: integratedTerminalPaymentMethod.paymentMethodsModel ? integratedTerminalPaymentMethod.paymentMethodsModel : null,
            rowStateId: integratedTerminalPaymentMethod.rowStateId ? integratedTerminalPaymentMethod.rowStateId : null,
            rowStateID: integratedTerminalPaymentMethod.rowStateID ? integratedTerminalPaymentMethod.rowStateID : null,
            storeID: integratedTerminalPaymentMethod.storeID ? integratedTerminalPaymentMethod.storeID : null
        })
    }

    filterDirectDebitPayment(directDebitIndex: number) {
        const operatingCompany = this.storeInfo && this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null;
        const storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
        this._customerService.getMemberBankDetails(this.memberInfo.memberId, storeId, operatingCompany).subscribe(
            (res: BonusInfo) => {
                if (!res || res && !res.accountNumber || res && res.accountNumber && !res.directDebitEnabled) {
                    this.integratedPaymentMethods.splice(directDebitIndex, 1);
                }
                this.buildPaymentForm();
            },
            (error) => {
                this.integratedPaymentMethods.splice(directDebitIndex, 1);
                this.buildPaymentForm();
            }
        );
    }

    /**
     * When edit cart button click
     */
    onEditCartClick(){
        this.isPaymentBlockEnabled = false;
        this.isEnterPaymentDetailsEnabled = false;
        this.placeOrderClicked = false;
        this.paymentComponentSettings.webOrderId = '';
        this.buildExternalPaymentForm();
        this.buildSplitPaymentForm();
        this.createPaymentMethodTypeForm();
    }

    /**
     * On External payment method radio button change
     */
    onExternalPaymentMethodChange(event:any,paymentMethodId:number,index:number){
        this.balanceOrderTotal = this.orderTotal;
        console.log("this.balanceOrderTotal",this.balanceOrderTotal);
        let externalPaymentForm:any = this.externalPaymentForm.get('payments') as FormArray;
        let i=0;
        for(i;i<externalPaymentForm.length;i++){
            if(i!==index){
                externalPaymentForm.controls[i].controls['amount'].setValue('');
                externalPaymentForm.controls[i].controls['paymentMethodId'].setValue('');
                externalPaymentForm.controls[i].controls['paymentNote'].setValue('');
                externalPaymentForm.controls[i].controls['amount'].clearValidators();
                externalPaymentForm.controls[i].controls['amount'].setErrors(null);
                externalPaymentForm.controls[i].controls['paymentMethodId'].clearValidators();
                externalPaymentForm.controls[i].controls['paymentMethodId'].setErrors(null);
                externalPaymentForm.controls[i].controls['paymentCheckNumber'].setValue('');
                externalPaymentForm.controls[i].updateValueAndValidity();
            }
        }
        externalPaymentForm.controls[index].controls['amount'].setValue('');
        externalPaymentForm.controls[index].controls['paymentMethodId'].setValue(this.getPaymentMethodId(this.posPaymentGroupEnum.External_Payment,index));
        externalPaymentForm.controls[index].controls['amount'].setValidators([Validators.required]);
        externalPaymentForm.controls[index].controls['amount'].updateValueAndValidity();
    }

    onSplitPaymentMethodChange($event:any,index:number){
        let payments:any = this.splitPaymentForm.get('payments') as FormArray;
        payments.controls[index].controls['amount'].setValue('');
        payments.controls[index].updateValueAndValidity();
    }

    /**
     * on payment method amount change
     */
    onPaymentMethodAmountChange(event:any,groupId:number,index:number){
        let paymentSelector = +this.posOrderFormGroup.controls['paymentSelector'].value;
        if(paymentSelector === this.posPaymentGroupEnum.External_Payment){
            let data:any = this.getSelectedExternalPaymentData();
            this.balanceOrderTotal = this.orderTotal - data.amount;
        }else if (paymentSelector === this.posPaymentGroupEnum.Split_Payment){
            // need to add split payment logic below value is temprory
            this.balanceOrderTotal = 0;
        } else if (paymentSelector === this.posPaymentGroupEnum.Integrated_Payments) {
            this.balanceOrderTotal = 0;
        }
    }
    getSelectedExternalPaymentData() {
        const externalPaymentForm: any = this.externalPaymentForm.get('payments') as FormArray;
        let i = 0;
        let data = {};
        for (i; i < externalPaymentForm.length; i++) {
            if (externalPaymentForm.controls[i].controls['paymentMethodId'].value
                && externalPaymentForm.controls[i].controls['paymentMethodId'].value !== ''
                && externalPaymentForm.controls[i].controls['paymentMethodId'].value > 0) {
                const payments = this.posPaymentMethods.filter((paymentMethod)=>
                paymentMethod.paymentMethodsModel.paymentGroupID === this.posPaymentGroupEnum.External_Payment);
                data = {
                    paymentGroupId: this.posPaymentGroupEnum.External_Payment,
                    paymentMethodName: PosPaymentMethodsEnum[+externalPaymentForm.controls[i].controls['paymentMethodId'].value],
                    paymentMethodId: externalPaymentForm.controls[i].controls['paymentMethodId'].value,
                    paymentStatus: externalPaymentForm.controls[i].controls['paymentStatus'].value,
                    paymentNote: externalPaymentForm.controls[i].controls['paymentNote'].value,
                    amount : externalPaymentForm.controls[i].controls['amount'].value,
                    paymentCheckNumber: externalPaymentForm.controls[i].controls['paymentCheckNumber'].value,
                };
            }
        }
        return data;
    }

    prepareIntegratedPaymentData() { 
        if (this.terminalDetails) {
            this.terminalPOIId = this.terminalDetails.deviceModel + "-" + this.terminalDetails.serialNumber;            
            this.paymentProcessingPopup.open();
            const orderDescription = this.products && this.products &&
                this.products.length > 0 ? this.products[0].name : 'order description';
            const initiatePaymentRequest: PayByLinkInitiatePayment = {
                email: this.memberInfo.email ? this.memberInfo.email : '',
                firstName: this.memberInfo.firstName,
                lastName: this.memberInfo.lastName,
                languageCode: this.languageCode,
                languageCulture: this._commonService.getLanguageCulture(this.storeInfo, this.countryCode, this.memberInfo),
                customerId: this.memberInfo.memberId,
                paymentMethodType: PaymentMethodTypes.Integrated_Terminal_Adyen,
                terminalDetails: this.terminalDetails,
                terminalPOIId: this.terminalPOIId,
                countryCode: this.selectedIsoCountryCode,
                amount: {
                    currency: this.storeInfo.currencyCode,
                    value: this.calculateOrderTotal()
                },
                distributorId: this.memberInfo.fboId,
                orderTypeId: this.orderType.POS,
                webOrderID: this.paymentComponentSettings.webOrderId,
                orderReferenceId: this.paymentComponentSettings.orderReferenceId,
                storeID: this.storeInfo.id,
                orderSource: OrderSources.POS,
                description: orderDescription,
                shippingAddress: this.getPayByLinkShippingAddress()
            }
            this._cacheService.set(CacheKey.SelectedTerminalDetails, this.paymentMethodTypeForm.controls['preselectTerminal'].value);            
            this.initiateTerminalPayment(initiatePaymentRequest);
        }
    }


    terminalSelection(terminalID: any) {
        this.terminalDetails = this.terminalOptions.find((x) => (x.id == +terminalID));
    }
    
    getSelectedCreditCardData(){
        let data = {};
        data = {
            paymentGroupId: this.posPaymentGroupEnum.Integrated_Payments,
            paymentMethodId: PosPaymentMethodsEnum.Credit_Card,
            paymentMethodName: PosPaymentMethodsEnum[1],
            paymentStatus: '',
            paymentNote: '',
            amount :'',
            paymentCheckNumber: '',
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null
        };
           return data;
    }

    /**
     * when confirm button click on split payment
     */
    onPaymentConfirmClick(index: number) {

    }
    /**
     * on change of Echeck
     */
    selectECheck(echeckDetails: PersonalCheck, isNewEcheck: boolean) {
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckValidationMessages = [];
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        } else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    }
    /**
     * when Echeck form is closed
     */
    onECheckFormClose() {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    }
    /**
     * buildEcheckForm
     */
    buildEcheckForm() {
        let phone = '';
        let email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if(this.phoneNumberFormat){
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }else{
                phone = this.memberInfo.phone;
            }
        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            reuse: [false],
            billingAddressId: [''],
            customMessage: [''],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    }
    validateNewECheck() {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            const echeckFormValue = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue.phone) {
                const phoneCode = PhoneCodesConstants.phoneCodes.find(x => echeckFormValue.phone.toUpperCase().indexOf(x.name) > -1);
                if (phoneCode) {
                    echeckFormValue.phone = echeckFormValue.phone;
                } else {
                     if(this.phoneNumberFormat){
                        echeckFormValue.phone = this._maskPipe.transform(echeckFormValue.phone, this.phoneNumberFormat);
                     }else{
                        echeckFormValue.phone = echeckFormValue.phone;
                     }
                }
            }
            const currentDate = new Date();
            const validateECheckReq: ValidateEcheckRequest = {
                accountNumber: echeckFormValue.accountNumber,
                accountType: echeckFormValue.accountType,
                bankName: echeckFormValue.bankName,
                routingNumber: echeckFormValue.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue.email,
                phone: echeckFormValue.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    }

    validateECheck(validateECheckReq: ValidateEcheckRequest) {
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe((response: ValidateEcheckResponse) => {
                if (response && response.success) {
                    this.savePersonalEcheck(validateECheckReq);
                } else if (response && !response.success && response.validations.length > 0) {
                    this.eCheckValidationMessages = response.validations.map(validation => validation.message);
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, error => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * save personal echecks
     */
    savePersonalEcheck(eCheckInfo: ValidateEcheckRequest) {
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe((response: any) => {
                if (response) {
                    this.eCheckTokenRes = response;
                    this.echeckSubmitted = false;
                    if (this.addNeweCheck) {
                        this.eCheckPaymentPopup.close();
                        const savedEChecks = JSON.parse(this.savedEChecks);
                        this.paymentComponentSettings.savedEChecks = savedEChecks;
                        if (this.echeckRequest) {
                            this.echeckRequest.id = +(atob(this.eCheckTokenRes));
                        }
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(this.eCheckTokenRes)));
                            this.getSavedEchecks();
                        } else {
                            this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(+(atob(this.eCheckTokenRes)));
                        }
                        // }
                    }
                    if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                        this.paymentFormBtn.nativeElement.focus();
                    }
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, (error: any) => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * map billing address for e-Check
     */
    getBillingAddressForECheck() {
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress = {
            id: null,
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2 || '',
            addressLine3: this.billingAddressInfo.addressLine3 || '',
            addressLine4: this.billingAddressInfo.addressLine4 || '',
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            countryId: this.billingAddressInfo.countryId,
            city: this.billingAddressInfo.city,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            country: this.billingAddressInfo.countryCode,
            countryCode: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            firstName: this.billingAddressInfo.shipToName || this.billingAddressInfo.name,
            phone: ''
        };
        return billingAddress;
    }
    /**
     * map Echeck Info for payment
     */
    getEcheckInfo() {
        const eCheckInfo = {
            bankName: this.echeckRequest.bankName,
            accountNumber: this.echeckRequest.accountNumber,
            routingNumber: this.echeckRequest.routingNumber,
            accountType: this.echeckRequest.accountType,
            mecTransactionID: '',
            nameOnBankAccount: this.echeckRequest.nameOnBankAccount,
            customMessage: '',
            reusable: this.echeckRequest.reusable,
            eCheckID: this.eCheckTokenRes ? parseInt(atob(this.eCheckTokenRes), 10) : this.echeckRequest ? this.echeckRequest.id : 0,
            email: this.echeckRequest.email,
            phone: this.echeckRequest.phone
        };
        return eCheckInfo;
    }

    /**
     * @description add mask while chnaging phone number
     *
     * @memberof EcheckComponent
     */
    onChangeEcheckPhone($event: any) {
        const value = this.echeckForm.controls['phone'].value;
        let updatedValue = value;
        const alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            } else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            } else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        } else {
            if (alphaNumericValue.length !== 3) {
                if(this.phoneNumberFormat){
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                }else{
                    updatedValue = value;
                }

            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    }

    onWorldpayXMLFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showWorldpayXml = false;
                sessionStorage.removeItem(CacheKey.OrderInfo);
                sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    }
    // ======================Worldpay End===================================================

    onAdyenPaymentFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
                sessionStorage.removeItem(CacheKey.OrderInfo);
                sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    }
    // ======================Adyen payment End===================================================

    onNIFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
                sessionStorage.removeItem(CacheKey.OrderInfo);
                sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    }

    onNexioFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNexioPayment = false;
                sessionStorage.removeItem(CacheKey.OrderInfo);
                sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        this.posOrderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPopup.close();
    }

    // getPaymentMethod by Store
    getPaymentMethodsByStore(memberTypeId?: number) {
        let fpc5PercentEnabled: boolean = false;
        if (this.appConfig && this.appConfig.fpc5PercentEnabled) {
            fpc5PercentEnabled = true;
        }
        this.credit_Card_show = this.money_Order_show = this.cash_on_delivery_show
            = this.bank_transfer_show = this.echeck_show = false;
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode,
            this.storeDefaultLanguage ? this.storeDefaultLanguage : this.languageCode,
            this.memberInfo ? this.memberInfo.memberTypeId : memberTypeId,
            this.memberInfo ? this.memberInfo.wholeSaleQualified : null, fpc5PercentEnabled).subscribe(response => {
                if (response) {
                    this.storePaymentInfo = response;
                    this.initializePaymentMethods();
                    this.storePaymentInfo.forEach(
                        paymentMethod => {
                            if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                                this.credit_Card_show = true;
                                if(paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN){
                                    this.isAdyenPayment = true;
                                }else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.NI){
                                    this.isNIPayment = true;
                                }
                                else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML){
                                    this.isWorldpayPayment = true;
                                }
                                else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO && this.enableNexioPaymentForPickUpCenter){
                                    this.isNexioPayment = true;
                                }
                            } else if (paymentMethod.paymentMethodId === PaymentType.Money_order) {
                                this.money_Order_show = true;
                            } else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                                this.echeck_show = true;
                            } else if (paymentMethod.paymentMethodId === PaymentType.Bank_Transfer) {
                                this.bank_transfer_show = true;
                                this.getBankDetails();
                            } else if (paymentMethod.paymentMethodId === PaymentType.Cash_On_Delivery) {
                                this.cash_on_delivery_show = true;
                            }
                        });
                    const option = this.credit_Card_show ? this.paymentTypeEnum.Credit_Card : this.echeck_show
                        ? this.paymentTypeEnum.eCheck : this.money_Order_show ? this.paymentTypeEnum.Money_order
                            : this.bank_transfer_show ? this.paymentTypeEnum.Bank_Transfer : this.cash_on_delivery_show ? this.paymentTypeEnum.Cash_On_Delivery : null;
                    if (option) {
                        //this.setPaymentMethod(option);
                    }
                    this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
                        this.orderSession.savePaymentMethod : false;
                    this.loadSavedCardsForMemberId(this.memberInfo.memberId, this.countryCode);
                    this.getSavedEchecks();
                }

            });
    }
    initializePaymentMethods(){
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    }

    setPaymentMethod = (value) => {
        this.posOrderFormGroup.controls['paymentSelector'].setValue(value.toString());
        this.onPaymentMethodChnage();
    }

    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderPromotionComponent
   */
    getOrderRules(storeInfo?: StoreConfig): void {
        const userInfo: Member = this.memberInfo;
        let isFboUpgradeFlow = false;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
            isFboUpgradeFlow = (+this.memberInfo.memberTypeId === this.memberTypeEnum.DISTRIBUTOR &&
                this.appConfig && this.appConfig.displayPurchaseLimitationMessage);
        }
        const orderRulesRequest: OrderRulesRequest = {
            countryCode: this.selectedIsoCountryCode,
            memberTitleId: userInfo ? userInfo.memberTitleId : MemberLevel.RETAIL,
            orderType: userInfo && userInfo.memberTitleId !== MemberLevel.RETAIL ? MemberOrderType.Personal
                : MemberOrderType.Retail
        };

        if (!isFboUpgradeFlow) {
            this.getBusinessOrderRules(orderRulesRequest);
        }

        this._orderService.getMemberOrderRestrictionsInfo(userInfo, this.selectedIsoCountryCode)
            .subscribe((response: any) => {
                if (response) {
                    this.restrictedDays = response.restrictedDays;
                    this.getMemberRankLevelHistory(orderRulesRequest, storeInfo, userInfo, isFboUpgradeFlow);
                }
            }, error => {
            });

        if (userInfo && userInfo.memberId && userInfo.memberTitleId !== MemberLevel.RETAIL) {
            if (!isFboUpgradeFlow) {
                this.getMemberOrderRules(userInfo, false);
            }
            this.getMemberCCOverrides(userInfo.memberId);
        }
    }

    getMemberRankLevelHistory(orderRulesRequest, storeInfo: StoreConfig, userInfo: Member, isFboUpgradeFlow: boolean): void {
        if (!isFboUpgradeFlow) {
            return;
        }
        this.isFBOValidationPending = true;
        this._commonService.getMemberRankLevelHistory(this.memberInfo.memberId, storeInfo.countryId)
            .subscribe(response => {
                if (response) {
                    this.memberLevelHistory = response;
                    const memberLevelInfo = this.memberLevelHistory
                        .find((memberLevel: MemberLevelHistory) => memberLevel.memberTitleId === MemberTitleExtEnums.PreferredCustomer);
                    const isMemberFboUpgraded = memberLevelInfo ? true : false;
                    const dateParts =  this.memberInfo.enrolmentDate ? this.memberInfo.enrolmentDate.split('-') : this.memberInfo.createdDate.split('-');
                    const enrollmentWindowDate = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);;
                    enrollmentWindowDate.setHours(0, 0, 0, 0);
                    enrollmentWindowDate.setDate(enrollmentWindowDate.getDate() + this.restrictedDays);
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    this.isFBOValidationPending = false;
                    if (isMemberFboUpgraded && (enrollmentWindowDate.getTime() > currentDate.getTime())) {
                        orderRulesRequest.optinFbo = true;
                        this.isMemberFboUpgraded = true;
                        this.getBusinessOrderRules(orderRulesRequest, userInfo, true);
                    } else {
                        this.isMemberFboUpgraded = false;
                        this.getBusinessOrderRules(orderRulesRequest);
                        this.getMemberOrderRules(userInfo, false);
                    }
                } else {
                    this.memberLevelHistory = [];
                    this.isMemberFboUpgraded = false;
                    this.isFBOValidationPending = false;
                    this.getMemberOrderRules(userInfo, false);
                    this.getBusinessOrderRules(orderRulesRequest);
                }
            });
    }

    getBusinessOrderRules(orderRulesRequest, userInfo?: Member, isFboUpgradeFlow?: boolean): void {
        this._orderService.getOrderBusinessRules(orderRulesRequest)
            .subscribe((response: any) => {
                if (response) {
                    this.orderRules = response;
                    if (isFboUpgradeFlow) {
                        this.getMemberOrderRules(userInfo, false, null, true);
                    }
                }
            }, error => {
            });
    }

    /**
     * Get member cc overrides
     * @param memberId
    */
    getMemberCCOverrides(memberId: number): void {
        this._customerService.getMemberCCOverride(this.storeId, memberId)
            .subscribe(response => {
                if (response && response.length) {
                    this.memberCCOverride = response[0];
                }
            }, (err: any) => {
            });
    }

    /** get Member Order rules
     * @description
     * @date 2019-05-20
     * @memberof OrderPromotionComponent
     */
    getMemberOrderRules(userInfo: Member, isBackOrderDate: boolean, requestUrl?: string, isFboUpgradeFlow?: boolean): void {
        this.memberOrderCCInfo = null;
        let fromDate;
        let toDate;
        if (userInfo) {
            userInfo.memberTitleId =
                this._orderService.getDowngradeTitleID(this.memberInfo.memberTypeId, this.memberInfo.memberTitleId);
        }
        if (isFboUpgradeFlow) {
            fromDate = this.memberInfo.enrolmentDate.substr(0, 10);
            const enrollDate = new Date(fromDate);
            const orderToDateStr = enrollDate.setDate(enrollDate.getDate() + this.restrictedDays);
            toDate = moment(orderToDateStr).format(DateConstants.DOBFormat);
        }
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate,
            this.selectedIsoCountryCode, userInfo.memberTitleId, null, fromDate, toDate)
            .subscribe((response: any) => {
                if (response) {
                    const memberOrderRules = response;
                    const frequencyType = this.isMemberFboUpgraded ? Constants.FREQUENCY_ABSOLUTE : Constants.FREQUENCY_MONTHLY;
                    this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter((x: any) => x.frequency === frequencyType)[0];
                    const validateOrderRule = this.verifyOrderRules(isBackOrderDate);
                    this.upgradeFboLimitExceeded = frequencyType === Constants.FREQUENCY_ABSOLUTE ?
                        validateOrderRule.purchaseLimitExceed : false;
                    this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                    this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                    this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                    this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                    this.cartLimitExceed = validateOrderRule.cartLimitExceed;
                    this.cartLimitNotReach = validateOrderRule.cartLimitNotReach;
                    if (requestUrl) {
                        this.placeOrder(requestUrl);
                    }
                }
            }, (error) => {
                this.enablePaymentBlock(false);
                const errorMessage: any = this._translatePipe.get('common.Sorry, Something Went Wrong: Please try again later.');
                this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
            });
    }

    /**
     * @description savePayment methos
     * @memberof OrderPromotionComponent
     */
    savePaymentMethodClicked(savePaymentMethod: boolean): void {
        this.savePaymentMethod = !savePaymentMethod;
    }

    /**
     * check member has access to place an order
     */
    checkMemberAccess() {
        if(this.isMemberEligibleToPlaceOrder){
            this.isMemberEligibleToPlaceOrder = true;
            this._commonService.createNotification('', this.memberTypeNotification.value, NotificationType.ERROR);
            return;
        }
        if (this.memberInfo && this.posOrderFormGroup && this.posOrderFormGroup.value.orderType === this.orderType.POS
            && this.restrictedDays > 0) {
            let enrollmentDate: Date;
            enrollmentDate = this.memberInfo.enrolmentDate ? new Date(this.memberInfo.enrolmentDate) : new Date(this.memberInfo.createdDate);
            enrollmentDate.setHours(0, 0, 0, 0);
            enrollmentDate.setDate(enrollmentDate.getDate() + this.restrictedDays);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (this.isFBOValidationPending) {
                return;
            }
            if (this.upgradeFboLimitExceeded && this.isMemberFboUpgraded) {
                this.displayPurchaseLimitMessage(enrollmentDate);
                this.isMemberHasAccessToOrder = this.calculateItemsSubTotal(this.storeInfo) > 0 ? true : false;
                return;
            } else if (this.isMemberFboUpgraded) {
                this.isMemberHasAccessToOrder = true;
                this._commonService.removeNotification(Constants.PURCHASE_WINDOW);
            } else if (enrollmentDate.getTime() > currentDate.getTime() && this.memberInfo.fboId && !this.isMemberFboUpgraded ) {
                let restrictPlacingOrder = true;
                if((this.memberInfo.sponsorTransactionalSourceId == transactional.SPNC && this.countryCode && environment.skipOrderRestrictionCountriesOnSPNCTransaction.includes(this.countryCode.toUpperCase()))){
                    restrictPlacingOrder = false;
                }
                if(restrictPlacingOrder){
                    const nextOrderDate = moment(enrollmentDate).format(DateConstants.DateFormat);
                    const orderPlacingError: any = this._translatePipe.get('order.Next Order is permitted after');
                    this._commonService.createNotification('', orderPlacingError.value + nextOrderDate, NotificationType.ERROR);
                    this.isMemberHasAccessToOrder = false;
                }

            }
        }
    }

    displayPurchaseLimitMessage(enrollmentDate): void {
        let purchaseLimitExceedMessage = this._translatePipe
            .get('order.Orders should not exceed an aggregate of ||maxValue|| until ||endDate||')['value'];
        const nextOrderEligibleDate = moment(enrollmentDate).format(DateConstants.DateFormat);
        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this.orderRules.maxValue,this.storeInfo);
        purchaseLimitExceedMessage = this._translateKey.transform(purchaseLimitExceedMessage,
            {
                maxValue: maxValue,
                endDate: nextOrderEligibleDate
            });
        this._commonService.createNotification('', purchaseLimitExceedMessage, NotificationType.ERROR, 0, Constants.PURCHASE_WINDOW);
    }

    /**
    *
    * @param items
    */
    getItemVolumeSum(items): number {
        return items
            .map(function (x) { return x.taxAmount; })
            .reduce(function (a, b) { return a + b; });
    }
    trackByItem(index: number): number {
        return index;
    }

    validateSubTotalBasedOnType(products: any[], subTotal?: any): boolean {
        let isThresholdCrossed = true;
        let itemSubTotal = subTotal;
        let orderMinValue = this.orderRules.minValue;
        let orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
            orderMinValue = this.orderRules.literatureMinValue;
            orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
            isThresholdCrossed = false;
        }
        if(itemSubTotal<=orderMinValue){
            this.isOverrideMinimumLimit===true?isThresholdCrossed=false:isThresholdCrossed=true;
        }
        return isThresholdCrossed;
    }

    isLiteratureValidation(products?: any): boolean {
        let literatureItems = this.getLiteratureItems(products);
        let isLiterature = literatureItems && literatureItems.length && products && products.length
            && products.length === literatureItems.length;
        return isLiterature;
    }

    /**
*
* @param items
*/
    getItemTotalSum(item): number {
        return this.calculateSubTotal(this.storeInfo,
            this.countryTaxInclusive, item, this.memberInfo, true);
    }

    /**
      * Get Total CartItems Cost.
      */
    calculateSubTotal(store: StoreConfig, taxInclusiveShippingCountry: boolean,
        item: any, userInfo: Member, taxCalculated: boolean): number {
        let subTotal = 0;
        if (item) {
            const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            if (userInfo && store && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item,
                    store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            } else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry,
                    isCalculateTaxExclusivePrice,userInfo);
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    }

    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    calculateSubtotalForVatAndNonVatRegisteredUser(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean,
        userInfo: Member, taxCalculated: boolean): number {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                const total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            } else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        } else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice.
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        } else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry,null, userInfo);
        }
    }

    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    calculateItemSubtotal(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean, isCalcTaxExclusivePrice?: boolean,userInfo?: Member): number {
        if (this.appConfig && this.appConfig.enableVatItemizationForNonVat) {
            let productPrice = 'applicablePrice';
            if (userInfo && (userInfo.vatRegistered || (!userInfo.vatRegistered && userInfo.memberTypeId === MemberTypeId.DISTRIBUTOR))) {
                productPrice = 'catalogPrice';
            }
            return Number(item[productPrice].
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;

        }
        else {
            return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        }
    }

    /**
     *
     */
    calculateDiscountAmount(item: any, displayPriceConfig: DisplayPriceConfig): number {
        let discountAmount = 0;
            discountAmount = (parseFloat(item.baseRetailPrice.toFixed(2)) * item.quantity) -
                (parseFloat(item.catalogPrice.toFixed(2)) * item.quantity);
        return discountAmount;
    }

    /**
  * Get Total CartItems Cost.
  */
    calculateItemsSubTotal(store: StoreConfig): number {
        let itemsSubTotal = 0;
        if (store) {
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
            const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            for (let i = 0; i < this.products.length; i++) {
                if (this.memberInfo && store.taxInclusive && isEnableVATCalculation) {
                    itemsSubTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(this.products[i],
                        store, this.countryTaxInclusive, this.memberInfo, true);
                } else {
                    itemsSubTotal += this.calculateItemSubtotal(this.products[i], store,
                        this.countryTaxInclusive, isCalculateTaxExclusivePrice,this.memberInfo);
                }
            }
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    }

    /**
    * @description this method will remove member discount offer for UK FPC second order
    * @memberof OrderSummaryNewComponent
    */
    removeMemberDiscountOffer(memberId: number): void {
        this._commonService.removeMemberDiscountOffer(memberId)
            .subscribe((response: any) => {
            });
    }

    calculateNetUnitPrice(product: any): number {
        const netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    }

    get cartItems(){
        return <FormArray>this.posOrderFormGroup.get('items');
    }

    /**
     * @description will be called on Quanity Change
     * @date 2020-11-02
     * @param {*} event
     * @memberof PosOrderPromotionComponent
     */
    onQuantityChange(event: any): void {
        this.isQuantityUpdate = true;
    }

    clearOutOfStockItems(): void {
        const items = this.posOrderFormGroup.get('items') as any;
        if (this.outOfStockItems && this.outOfStockItems.length) {
            const productIds = this.outOfStockItems.map((product:any) => product.productItem.id);
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.isSubmitted = false;
            this.outOfStockModal.close();
        }
    }

    closeOutOfStockForm(){
        this.outOfStockModal.close();
        this.isSubmitted = false;
    }

    removeOutOfStockItems(items: FormArray, productIds: number[]) {
        productIds.forEach((id: number) => {
            const productIndex = items.value.findIndex((product) => product.productId === id);
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    }

    displayPaymentNote(index: number) {
        let payments: any = this.externalPaymentForm.controls['payments'] as FormArray;
        let displayNote = false;
        if (payments && payments.controls[index] && payments.controls[index].controls['paymentMethodId']) {
            const paymentMethodId = +payments.controls[index].controls['paymentMethodId'].value;
            if (paymentMethodId &&
                ((paymentMethodId === PosPaymentMethodsEnum.Personal_Check))) {
                displayNote = true;
                payments.controls[index].controls['paymentNote'].setValidators([Validators.maxLength(15)]);
                payments.controls[index].controls['paymentNote'].updateValueAndValidity();
            } 
            else {
                displayNote = false;
            }
        }
        return displayNote;
    }
    
    displayPaymentCheckNumber(index: number) {
        let payments: any = this.externalPaymentForm.controls['payments'] as FormArray;
        let displayCheckNumber = false;
        if (payments && payments.controls[index] && payments.controls[index].controls['paymentMethodId']) {
            const paymentMethodId = +payments.controls[index].controls['paymentMethodId'].value;
            if(paymentMethodId && paymentMethodId === PosPaymentMethodsEnum.Bonus_Check){
                displayCheckNumber = true;
                payments.controls[index].controls['paymentCheckNumber'].setValidators([Validators.maxLength(15)]);
                payments.controls[index].controls['paymentCheckNumber'].updateValueAndValidity();
            }
            else {
                displayCheckNumber = false;
            }
        }
        return displayCheckNumber;
    }

    buildPayByLinkForm() {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    }

    emailCheck() {
        if(this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        } else {
            this.isPayByLinkValid = false;
        }
    }

 /**
  * disabling Enter Payment Detail Button when Product Quantity is updated in CART
  */
     disablePaymentDetailButton(): void {
        this.taxCalculationStatus = true;
        this.isEnterPaymentDetailsEnabled = true;
    }

    /**
     * Checks Whether Order Can be BackDated or Not
     * @param timeZoneOffset
     */
    isBackDateOrderAvailable = (timeZoneOffset: number, operatingCountry: string) => {
        this.enableBackDateOrder = false;
        let processingMonth;
        let processingYear;
        var date = new Date();
        if (date.getMonth() === 0) {
            processingMonth = 12;
            processingYear = date.getFullYear() - 1;
        } else {
            processingMonth = date.getMonth();
            processingYear = date.getFullYear();
        }
        if (operatingCountry && processingMonth && processingYear) {
            this._customerService.getBonusRunStatusDetails(operatingCountry, processingMonth, processingYear).subscribe((response) => {
                if (response && response.success && response.bonusStatus && response.validations.length === 0) {
                    if ((response.bonusStatus.toLowerCase() === BonusConstants.Open.toLowerCase())
                        || (response.bonusStatus.toLowerCase() === BonusConstants.Restricted.toLowerCase())) {
                        this._orderService.isBackDateOrderAllowed(timeZoneOffset, this.countryCode).subscribe(response => {
                            if (response && response.success) {
                                this.enableBackDateOrder = true;
                            } else {
                                this.enableBackDateOrder = false;
                            }
                        }, (error) => {
                            this.enableBackDateOrder = false;
                        });
                    }
                }
            }, (error) => {
                this.enableBackDateOrder = false;
            });
        }
        
    }

    /**
     * event for OrderBackDate CheckBox change
     */
     backDateOrderChange(event) {
        this.posOrderFormGroup.controls['backDateOrder'].setValue(event.target.checked);
    }

    saveMemberActivityLog(memberId: number, key: MemberActivityLogType): void {
        const activityLogKeys: ActivityLogKey[] = [];
        if(key === MemberActivityLogType.Override_Minimum_Limit){
            activityLogKeys.push({
                key:MemberActivityLogType.Override_Minimum_Limit,
                value:Constants.OVERRIDE_MINIMUM_LIMIT
            })
        }
        this._commonService.saveMemberActivity(memberId, activityLogKeys).subscribe();
    }

    
    getMembergovernmentIdentificationsInfo(memberId: number) {
        if(memberId){
            this._customerService.getMembergovernment_identifications(memberId).subscribe(response=>{
              if(response){
                this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                this.memberInfo.vatDetailModel = response.vatDetailModel;
              }
            });
        }

    }


    savedCardInfo(savedcardDetails: any) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPopup.close();
            this.showNexioPayment = false;
            if(this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                const savedCard=this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id ===savedcardDetails.id) {
                    this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }  else {
                    this.posOrderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);

                }
                this.selectedpayvisionCardInfo = savedcardDetails;
            }
    }

}

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/pos-orders/pos-order-promotion.component.ts